/* Nederlands — Dutch */
const nl = {
  nav: {
    home: 'Startpagina',
    imageConverter: 'Afbeeldingsconverter',
    imageCompressor: 'Afbeeldingscompressor',
    otherTools: 'Andere Tools',
    resizeImage: 'Formaat Wijzigen',
    cropImage: 'Afbeelding Bijsnijden',
    photoEditor: 'Fotobewerker',
    removeBackground: 'Achtergrond Verwijderen',
    watermarkImage: 'Watermerk',
    qrCodeGenerator: 'QR-code Generator',
    qrCodeScanner: 'QR-code Scanner',
    aboutUs: 'Over Ons',
    faceBlur: 'Gezicht Vervagen',
  },

  hero: {
    heading: 'Alle Afbeeldingstools Die Je Nodig Hebt',
    subheading: 'Gratis online tools om afbeeldingen te converteren, comprimeren, vergroten/verkleinen, bijsnijden en bewerken. Alles verwerkt in de browser — snel en veilig.',
  },

  tools: {
    compressImage: { title: 'Afbeelding Comprimeren', desc: 'Comprimeer JPG, PNG, SVG en GIF met behoud van kwaliteit.' },
    resizeImage: { title: 'Formaat Afbeelding Wijzigen', desc: 'Wijzig formaat in procenten of pixels.' },
    cropImage: { title: 'Afbeelding Bijsnijden', desc: 'Snijd eenvoudig JPG, PNG en GIF bij.' },
    convertToJpg: { title: 'Converteren naar JPG', desc: 'Converteer PNG, GIF, TIF, SVG, WEBP en andere naar JPG.' },
    convertFromJpg: { title: 'Converteren van JPG', desc: 'Converteer JPG naar PNG en GIF.' },
    qrCodeGenerator: { title: 'QR-code Generator', desc: 'Maak aangepaste QR-codes voor URL, tekst, WiFi, contacten en meer.' },
    qrCodeScanner: { title: 'QR-code Scanner', desc: 'Direct QR-codes scannen met camera of uploaden van afbeelding.' },
    blurFace: { title: 'Gezicht Vervagen', desc: 'Automatisch gezichten detecteren en vervagen voor privacybescherming.' },
    removeBackground: { title: 'Achtergrond Verwijderen', desc: 'Verwijder achtergronden snel met hoge nauwkeurigheid.' },
    watermarkImage: { title: 'Watermerk Toevoegen', desc: 'Voeg watermerken toe aan afbeeldingen in enkele seconden.' },
  },

  whyChoose: {
    label: 'Waarom Wij',
    heading: 'Een Slimmere Manier om Afbeeldingen te Bewerken',
    subheading: 'Vertrouwd door duizenden makers, ontwerpers en ontwikkelaars wereldwijd.',
    reasons: {
      fast: { title: 'Razend Snel', desc: 'Alle verwerking vindt direct in uw browser plaats. Geen uploads naar externe servers.' },
      private: { title: '100% Veilig en Privé', desc: 'Uw bestanden verlaten nooit uw apparaat. Wij slaan uw afbeeldingen niet op.' },
      noLimits: { title: 'Geen Limieten, Geen Registratie', desc: 'Gebruik alle tools zoveel u wilt — volledig gratis.' },
      quality: { title: 'Professionele Kwaliteit', desc: 'Onze algoritmen leveren resultaten op professioneel niveau.' },
      batch: { title: 'Batchverwerking', desc: 'Verwerk meerdere bestanden tegelijk.' },
      everywhere: { title: 'Werkt Overal', desc: 'Werkt perfect op desktop, tablet en telefoon.' },
    },
    stats: {
      imagesProcessed: 'Verwerkte Afbeeldingen',
      countriesServed: 'Bediende Landen',
      uptime: 'Uptime',
      freeTools: 'Gratis Tools',
    },
  },

  footer: {
    tagline: 'Gratis online afbeeldingstools — converteer, comprimeer, verander formaat, snijd bij en bewerk afbeeldingen in seconden.',
    imageTools: 'Afbeeldingstools',
    moreTools: 'Meer Tools',
    company: 'Bedrijf',
    contact: 'Contact',
    allRightsReserved: 'Alle rechten voorbehouden.',
    privacyPolicy: 'Privacybeleid',
    termsOfService: 'Servicevoorwaarden',
  },

  faq: {
    badge: 'FAQ',
    heading: 'Veelgestelde Vragen',
    subheading: 'Snelle antwoorden op veelvoorkomende vragen over deze tools.',
    stillHaveQuestions: 'Heeft u nog vragen? We helpen u graag!',
    reachOut: 'Neem Contact Op',
    questionHeader: 'Vraag',
  },

  contactForm: {
    badge: 'Neem Contact Op',
    title: 'Neem Contact Op',
    subtitle: 'We horen graag van u. Stuur ons een bericht!',
    nameLabel: 'Naam',
    namePlaceholder: 'Uw volledige naam',
    emailLabel: 'E-mail',
    emailPlaceholder: 'u@email.nl',
    subjectLabel: 'Onderwerp',
    subjectPlaceholder: 'Waar gaat het over?',
    messageLabel: 'Bericht',
    messagePlaceholder: 'Schrijf hier uw bericht…',
    errName: 'Naam is verplicht',
    errEmail: 'E-mail is verplicht',
    errEmailInvalid: 'Voer een geldig e-mailadres in',
    errSubject: 'Onderwerp is verplicht',
    errMessage: 'Bericht is verplicht',
    sending: 'Verzenden…',
    send: 'Bericht Verzenden',
    successTitle: 'Bericht Verzonden!',
    successMsg: 'Bedankt voor uw bericht. We nemen snel contact op.',
    sendAnother: 'Nog een Bericht',
    sendError: 'Er is iets misgegaan. Probeer het opnieuw.',
  },

  about: {
    label: 'Over Ons',
    heading: 'Gebouwd voor Makers, door Makers',
    subheading: 'Wij geloven dat krachtige afbeeldingstools gratis, snel en voor iedereen toegankelijk moeten zijn.',
    missionTitle: 'Onze Missie',
    missionText: 'photremium.com is opgericht met één eenvoudig doel: de meest intuïtieve, snelste en meest privacyvriendelijke afbeeldingsbewerkingservaring op het web bieden.',
    privacyTitle: 'Privacy Voorop',
    privacyText: 'Wij uploaden, opslaan of verwerken uw afbeeldingen op afstand niet. Alles blijft op uw apparaat.',
    techTitle: 'Moderne Technologie',
    techText: 'Gebouwd met de nieuwste webtechnologieën, waaronder WebAssembly, Canvas API en modern React.',
    communityTitle: 'Gemeenschapsgedreven',
    communityText: 'Elke functie is geïnspireerd door feedback van echte gebruikers.',
    globalTitle: 'Globaal Bereik',
    globalText: 'Gebruikt door makers uit meer dan 120 landen.',
  },

  seo: {
    homeTitle: 'photremium.com — Gratis Online Afbeeldingsconverter, Compressor en Bewerker',
    homeDesc: 'Converteer, comprimeer, verander formaat, snijd bij en bewerk afbeeldingen gratis online.',
    homeKeywords: 'afbeeldingsconverter, afbeeldingscompressor, formaat wijzigen, afbeelding bijsnijden, fotobewerker',
    aboutTitle: 'Over photremium.com — Onze Missie',
    aboutDesc: 'Leer meer over photremium.com, de gratis online afbeeldingstoolkit vertrouwd door miljoenen.',
    aboutKeywords: 'over photremium.com, afbeeldingstools, gratis afbeeldingsbewerker',
  },

      privacyPolicyPage: {
    seo: {
      title: 'Privacybeleid — Photremium | Geen serveruploads, geen gegevensopslag',
      description: 'In het privacybeleid van Photremium wordt uitgelegd hoe wij uw privacy beschermen. Alle beeldverwerking gebeurt 100% in uw browser: er worden geen bestanden geüpload naar een server, er worden geen persoonlijke gegevens verzameld, geen tracking.',
      ogTitle: 'Privacybeleid — Photremium | Geen uploads, geen opslag',
      ogDescription: 'Uw bestanden blijven op uw apparaat staan. Photremium verwerkt alle afbeeldingen lokaal in uw browser zonder servercontact, zonder opgeslagen gegevens en zonder tracking.',
      twitterTitle: 'Privacybeleid — Photremium',
      twitterDescription: '100% browsergebaseerde beeldtools. Geen uploads, geen opslag, geen tracking. Lees ons volledige privacybeleid.',
      schemaName: 'Privacybeleid - Photremium',
      schemaDescription: 'Photremium Privacybeleid - geen serveruploads, geen gegevens opgeslagen, 100% beeldverwerking in de browser.'
    },
    hero: {
      badge: 'Privacybeleid',
      titlePrefix: 'Uw privacy is onze',
      titleHighlight: 'Topprioriteit',
      subPrefix: 'phototremium.com is gebouwd op een eenvoudig principe:',
      subStrong: 'uw bestanden verlaten nooit uw apparaat',
      subSuffix: 'Elke afbeeldingstool op deze site draait volledig in uw browser. Geen uploads. Geen wolk. Geen compromis.',
      effectiveLabel: 'Effectief',
      lastUpdatedLabel: 'Laatst bijgewerkt',
      worldwideLabel: 'Geldt wereldwijd'
    },
    trustCards: [
      {
        title: 'Geen serveruploads',
        desc: 'Uw bestanden verlaten nooit uw apparaat. Alle verwerking vindt 100% in de browser plaats.'
      },
      {
        title: 'Geen gegevensopslag',
        desc: 'We slaan niets op over u, uw afbeeldingen of uw activiteit.'
      },
      {
        title: 'Geen tracking',
        desc: 'Geen gedragsregistratie, geen vingerafdrukken, geen profilering.'
      },
      {
        title: 'AVG-vriendelijk',
        desc: 'Vanaf de basis ontworpen om de wereldwijde privacyregelgeving te respecteren.'
      }
    ],
    contentsTitle: 'Inhoud',
    toc: {
      overview: 'Overzicht',
      'no-upload': 'Geen serververwerking',
      'data-collect': 'Gegevens die we verzamelen',
      cookies: 'Cookies en opslag',
      'third-party': 'Diensten van derden',
      analytics: 'Analyse',
      children: 'Privacy van kinderen',
      rights: 'Uw rechten',
      security: 'Beveiliging',
      changes: 'Beleidswijzigingen',
      contact: 'Neem contact met ons op'
    },
    sections: {
      overview: {
        title: '1. Overzicht',
        subtitle: 'Wat dit beleid dekt',
        p1Prefix: 'Dit privacybeleid beschrijft hoe',
        p1Middle: '("wij", "ons" of "onze") verwerkt - of beter gezegd,',
        p1Italic: 'hanteert niet',
        p1Suffix: 'uw persoonlijke gegevens wanneer u onze gratis online beeldhulpmiddelen gebruikt op',
        p2: 'In tegenstelling tot traditionele webapplicaties die bestanden ter verwerking naar externe servers sturen, gebruikt photremium.com moderne browser-API\'s (Canvas API, WebAssembly, WebWorkers) om elke bewerking lokaal op uw apparaat uit te voeren. Het resultaat: geen datatransmissie, geen opslag, geen risico.',
        calloutLabel: 'Duidelijke Engelse samenvatting:',
        calloutText: 'We kunnen uw afbeeldingen niet zien, dat willen we niet, en onze technologie is speciaal zo ontworpen dat we dat nooit kunnen zien.'
      },
      noUpload: {
        title: '2. Geen serververwerking – ooit',
        subtitle: 'Hoe onze tools daadwerkelijk werken',
        introPrefix: 'Elke tool op photremium.com – beeldconverter, compressor, resizer, achtergrondverwijderaar, gezichtsvervaging, watermerk, bijsnijden en QR-codetools – verwerkt uw bestanden',
        introStrong: '100% in uw webbrowser',
        introSuffix: 'met behulp van JavaScript en WebAssembly aan de clientzijde.',
        points: [
          {
            label: 'Er vindt nooit een bestandsupload plaats.',
            text: 'Wanneer u een bestand selecteert, wordt het gelezen door de File API van uw browser en in het geheugen verwerkt; het wordt nooit via het netwerk verzonden.'
          },
          {
            label: 'Geen enkele server ontvangt uw afbeelding.',
            text: 'Ons CDN levert alleen de HTML-, CSS- en JavaScript-items die nodig zijn om de app uit te voeren, niet uw bestanden.'
          },
          {
            label: 'Geen tijdelijke opslag.',
            text: 'Verwerkte resultaten bestaan ​​alleen in uw browsergeheugen en worden vrijgegeven wanneer u de pagina sluit of weg navigeert.'
          },
          {
            label: 'Werkt offline.',
            text: 'De meeste tools blijven functioneren zonder internetverbinding nadat de pagina voor het eerst is geladen – verder bewijs dat er geen server bij betrokken is.'
          }
        ],
        callout: 'U kunt dit zelf verifiëren: open het tabblad Netwerk van uw browser in Developer Tools, selecteer een afbeelding en controleer of er geen bestandsgegevens naar een externe server worden verzonden.'
      },
      dataCollect: {
        title: '3. Gegevens die we verzamelen (en niet verzamelen)',
        subtitle: 'Volledige transparantie over datapraktijken',
        headers: {
          type: 'Gegevenstype',
          collected: 'Verzameld?',
          whereWhy: 'Waar / waarom'
        },
        rows: [
          {
            type: 'Uw afbeeldingen / bestanden',
            badge: 'Nooit',
            variant: 'groente',
            showX: true,
            whereWhy: 'Volledig verwerkt in uw browser - nooit verzonden'
          },
          {
            type: 'Naam / e-mailadres',
            badge: 'Nooit',
            variant: 'groente',
            showX: true,
            whereWhy: 'Er is geen account of aanmelding vereist om welke tool dan ook te gebruiken'
          },
          {
            type: 'IP-adres',
            badge: 'Minimaal',
            variant: 'grijs',
            showX: false,
            whereWhy: 'Standaard webserverlogboeken worden <= 30 dagen bewaard, niet gebonden aan identiteit'
          },
          {
            type: 'Browser/OS-type',
            badge: 'Minimaal',
            variant: 'grijs',
            showX: false,
            whereWhy: 'Automatisch verzonden door uw browser; alleen gebruikt voor compatibiliteit'
          },
          {
            type: 'Bezochte pagina\'s / klikken',
            badge: 'Geaggregeerd',
            variant: 'blauw',
            showX: false,
            whereWhy: 'Alleen anonieme analyses (geen persoonlijke identificatie)'
          },
          {
            type: 'Taalvoorkeur',
            badge: 'Alleen lokaal',
            variant: 'blauw',
            showX: false,
            whereWhy: 'Opgeslagen in localStorage op uw apparaat - nooit naar ons verzonden'
          },
          {
            type: 'Betalings-/financiële gegevens',
            badge: 'Nooit',
            variant: 'groente',
            showX: true,
            whereWhy: 'phototremium.com is volledig gratis en er zijn geen betalingen vereist'
          }
        ]
      },
      cookies: {
        title: '4. Cookies en lokale opslag',
        subtitle: 'Wat wordt opgeslagen op uw apparaat',
        intro: 'phototremium.com gebruikt geen advertentiecookies, geen cross-site tracking cookies en geen cookies van derden. De enige browseropslag die we gebruiken is voor essentiële sitefunctionaliteit.',
        points: [
          {
            label: 'Taalvoorkeur',
            text: 'Opgeslagen in localStorage, zodat de site uw voorkeurstaal onthoudt tussen bezoeken. Nooit verzonden naar onze servers.'
          },
          {
            label: 'Thema-/UI-voorkeuren',
            text: 'Als u een weergavevoorkeur instelt, wordt deze alleen lokaal op uw apparaat opgeslagen.'
          },
          {
            label: 'Geen sessiecookies.',
            text: 'phototremium.com heeft geen inlogsysteem, dus er worden nooit sessie-ID-cookies geschreven.'
          }
        ],
        callout: 'U kunt op elk moment alle lokale opslag van photremium.com wissen via uw browserinstellingen (Instellingen -> Privacy -> Browsegegevens wissen -> Gegevens in cache en cookies). Als u dit wel doet, heeft dit geen invloed op uw vermogen om de tools te gebruiken.'
      },
      thirdParty: {
        title: '5. Diensten van derden',
        subtitle: 'Externe diensten die we gebruiken en waarom',
        intro: 'phototremium.com gebruikt een minimale set vertrouwde services van derden, uitsluitend voor infrastructuur en prestaties. Geen van deze services ontvangt uw afbeeldingen of persoonlijk identificeerbare informatie.',
        headers: {
          service: 'Dienst',
          purpose: 'Doel',
          dataShared: 'Gegevens gedeeld',
          privacyPolicy: 'Privacybeleid'
        },
        rows: [
          {
            service: 'Cloudflare-pagina\'s',
            purpose: 'Hosting en CDN-levering van sitemiddelen',
            dataShared: 'IP-adres, HTTP-headers (standaard)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Lettertype Geweldig',
            purpose: 'Pictogramlettertypen geladen vanuit CDN',
            dataShared: 'IP-adres (alleen CSS-verzoek)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google-lettertypen',
            purpose: 'Lettertype laden (indien van toepassing)',
            dataShared: 'IP-adres (alleen lettertypeverzoek)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'We delen uw gegevens niet met adverteerders, datamakelaars of andere derde partijen dan de hierboven genoemde infrastructuuraanbieders.'
      },
      analytics: {
        title: '6. Analyses',
        subtitle: 'Geaggregeerde, privacy respecterende gebruiksgegevens',
        introPrefix: 'Om te begrijpen welke tools populair zijn en hoe we de site kunnen verbeteren, kunnen we gegevens verzamelen',
        introStrong: 'geaggregeerd, geanonimiseerd',
        introSuffix: 'gebruiksstatistieken zoals:',
        points: [
          'Aantal paginaweergaven per tool (geen gebruikersidentificatie)',
          'Verwijzingsbron (bijv. Google-zoekopdracht, directe link) – geen persoonlijke gegevens',
          'Geografische gegevens op landniveau (geen stad of exacte locatie)',
          'Browser-/apparaattype voor compatibiliteitsanalyse'
        ],
        calloutLabel: 'Er worden geen gegevens aan u persoonlijk gekoppeld.',
        calloutText: 'Wij maken geen gebruik van Google Analytics of Meta Pixel. Alle analyses die we gebruiken zijn tools waarbij de privacy voorop staat (bijvoorbeeld Plausibel of iets dergelijks).'
      },
      children: {
        title: '7. Privacy van kinderen',
        subtitle: 'COPPA en naleving van de kinderveiligheid',
        p1: 'phototremium.com verzamelt niet bewust persoonlijke gegevens van kinderen jonger dan 13 jaar (of 16 jaar in de Europese Unie onder de AVG). Omdat we van geen enkele gebruiker persoonlijke gegevens verzamelen, is er niets speciaals te doen voor jongere gebruikers; de site is voor iedereen even veilig.',
        p2Prefix: 'Als u denkt dat een kind op een of andere manier persoonlijke gegevens heeft verstrekt via ons contactformulier, neem dan onmiddellijk contact met ons op via',
        p2Suffix: 'en we zullen het onmiddellijk verwijderen.'
      },
      rights: {
        title: '8. Uw rechten',
        subtitle: 'AVG, CCPA en wereldwijde privacyrechten',
        intro: 'Omdat phototremium.com geen persoonlijk identificeerbare informatie verzamelt, zijn de meeste rechten van de betrokkenen triviaal van toepassing: er zijn geen gegevens over u die u kunt openen, corrigeren of verwijderen. Niettemin erkennen en respecteren wij de volgende rechten volledig:',
        points: [
          {
            label: 'Recht op toegang',
            text: 'U kunt een kopie opvragen van alle gegevens die wij over u bewaren. (Er is niets anders dan geanonimiseerde logbestanden.)'
          },
          {
            label: 'Recht op correctie',
            text: 'U kunt verzoeken om correctie van onjuiste persoonsgegevens.'
          },
          {
            label: 'Recht op verwijdering ("Recht om vergeten te worden")',
            text: 'U kunt verzoeken om verwijdering van alle persoonlijke gegevens die wij bewaren (AVG Art. 17, CCPA).'
          },
          {
            label: 'Recht van bezwaar/opt-out',
            text: 'U kunt zich afmelden voor elke toekomstige verzameling van analyses door gebruik te maken van een opt-out- of advertentieblokkeringstool op browserniveau.'
          },
          {
            label: 'Recht op gegevensportabiliteit',
            text: 'Al uw werk wordt rechtstreeks naar uw apparaat gedownload – er is geen exportverzoek nodig.'
          }
        ],
        callout: 'Deze rechten zijn van toepassing op alle gebruikers wereldwijd, ongeacht het rechtsgebied. Wij hanteren de hoogste standaard (AVG) als uitgangspunt.'
      },
      security: {
        title: '9. Beveiliging',
        subtitle: 'Hoe wij uw ervaring beschermen',
        intro: 'De veiligste gegevens zijn gegevens die nooit worden verzameld. De client-side architectuur van phototremium.com betekent dat een serverlek uw bestanden niet kan blootleggen, omdat uw bestanden nooit op onze servers staan. Aanvullende beveiligingsmaatregelen zijn onder meer:',
        points: [
          {
            label: 'HTTPS-handhaving',
            text: 'Al het verkeer tussen uw browser en ons CDN wordt gecodeerd via TLS 1.2+ met HSTS.'
          },
          {
            label: 'Inhoudsbeveiligingsbeleid (CSP)',
            text: 'Strenge headers voorkomen cross-site scripting en inline scriptinjectie.'
          },
          {
            label: 'Regelmatige afhankelijkheidsaudits',
            text: 'We controleren en updaten npm-pakketten regelmatig om bekende kwetsbaarheden te patchen.'
          }
        ],
        disclosurePrefix: 'Verantwoorde openbaarmaking',
        disclosureTextPrefix: 'Een beveiligingsprobleem gevonden? E-mail ons op',
        disclosureTextSuffix: 'en wij reageren binnen 48 uur.'
      },
      changes: {
        title: '10. Wijzigingen in dit beleid',
        subtitle: 'Hoe we omgaan met beleidsupdates',
        intro: 'We kunnen dit privacybeleid van tijd tot tijd bijwerken om wijzigingen in onze praktijken, hulpmiddelen of wettelijke vereisten weer te geven. Wanneer we dat doen:',
        points: [
          {
            label: '"Laatst bijgewerkt"',
            text: 'datum bovenaan deze pagina wordt herzien.'
          },
          {
            label: 'Materiële veranderingen',
            text: 'zal gedurende minimaal 30 dagen via een prominente kennisgeving op de startpagina worden gecommuniceerd.'
          },
          {
            label: 'Vorige versies',
            text: 'van dit beleid zal worden gearchiveerd en op verzoek beschikbaar zijn.'
          }
        ],
        outro: 'Voortgezet gebruik van phototremium.com nadat de wijzigingen zijn gepubliceerd, betekent acceptatie van het bijgewerkte beleid. Wij raden u aan deze pagina regelmatig te bekijken.'
      },
      contact: {
        title: '11. Contact- en gegevensverzoeken',
        subtitle: 'Neem contact op over privacy',
        p1Prefix: 'Voor vragen, zorgen of formele gegevensverzoeken met betrekking tot dit privacybeleid kunt u contact met ons opnemen. Wij streven ernaar om op alle privacygerelateerde vragen binnen onze website te reageren',
        p1Strong: '5 werkdagen'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Privacyvragen?',
      privacyQuestionsDesc: 'Stuur ons uw privacyvragen, gegevensverzoeken of zorgen en wij zullen snel reageren.',
      versionHistoryTitle: 'Versiegeschiedenis',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Nieuw!',
    download: 'Downloaden',
    downloadAll: 'Alles Downloaden',
    downloadAs: 'Downloaden als:',
    zip: 'ZIP',
    separate: 'Apart',
    upload: 'Uploaden',
    dragDrop: 'Afbeeldingen hierheen slepen of klikken om te bladeren',
    remove: 'Verwijderen',
    reset: 'Resetten',
    apply: 'Toepassen',
    cancel: 'Annuleren',
    clear: 'Wissen',
    close: 'Sluiten',
    save: 'Opslaan',
    processing: 'Verwerken...',
    noFiles: 'Geen bestand geselecteerd',
    selectFiles: 'Bestanden Selecteren',
    or: 'of',
    browseFiles: 'Bladeren',
    dropHere: 'Afbeeldingen hierheen slepen',
    chooseFiles: 'Bestanden Kiezen',
    pasteHint: 'U kunt ook een afbeelding plakken',
    quality: 'Kwaliteit',
    width: 'Breedte',
    height: 'Hoogte',
    format: 'Formaat',
    compression: 'Compressie',
    preview: 'Voorbeeld',
    original: 'Origineel',
    result: 'Resultaat',
    before: 'Voor',
    after: 'Na',
    startOver: 'Opnieuw Beginnen',
    startOverConfirm: 'Alle afbeeldingen verwijderen en opnieuw beginnen?',
    addMoreImages: 'Meer Afbeeldingen Toevoegen',
    addImage: 'Afbeelding Toevoegen',
    images: 'afbeeldingen',
    totalSize: 'Totale Grootte',
    size: 'Grootte',
    type: 'Type',
    unsavedEdits: 'U heeft niet-opgeslagen wijzigingen. Deze pagina verlaten?',
    compareSlider: 'Vergelijkingsschuifregelaar',
    toggleToolsPanel: 'Toolspaneel Wisselen',
    closePanel: 'Paneel Sluiten',
    zoomIn: 'Inzoomen',
    zoomOut: 'Uitzoomen',
    fit: 'Aanpassen',
    none: 'Geen',
  },

  compressor: {
    seo: {
      uploadTitle: 'Afbeeldingscompressor — Comprimeer JPG, PNG, SVG, GIF Gratis | photremium.com',
      uploadDesc: 'Comprimeer JPG, PNG, SVG en GIF gratis online. Verklein bestandsgrootte tot 80% met behoud van kwaliteit.',
      uploadKeywords: 'afbeeldingscompressor, jpg comprimeren, png comprimeren, afbeeldingsgrootte verkleinen',
      workspaceTitle: 'Afbeeldingen Comprimeren — photremium.com Afbeeldingscompressor',
      workspaceDesc: 'Pas het compressieniveau aan en download geoptimaliseerde afbeeldingen.',
      workspaceKeywords: 'afbeeldingen comprimeren, afbeeldingen optimaliseren',
    },
    title: 'Afbeeldingscompressor',
    desc: 'Comprimeer JPG, PNG en GIF tot 80%. Snel en veilig.',
    toCompress: 'te comprimeren',
    compressionForAll: 'Compressie voor alle afbeeldingen',
    summary: 'Samenvatting',
    originalSize: 'Originele Grootte',
    compressed: 'Gecomprimeerd',
    saved: 'Bespaard',
    compressionLabel: 'Compressie:',
    compressing: 'Comprimeren…',
    compressDownload: 'Comprimeren en Downloaden',
    lowQualityWarning: 'Hoge compressie kan de beeldscherpte merkbaar verminderen.',
    blog: {
      tocTitle: 'Inhoud',
      title: 'Afbeeldingscompressor Blog',
      formatsIntro: 'Onze tool ondersteunt alle afbeeldingsformaten, zodat je elke afbeelding naadloos kunt comprimeren. De volledige lijst met formaten staat hieronder:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Wat is een afbeeldingscompressor?',
          paragraphs: [
            'Een afbeeldingscompressor is software of een online dienst die de bestandsgrootte van een afbeelding verkleint terwijl de visuele kwaliteit behouden blijft. Te veel comprimeren kan de kwaliteit echter zichtbaar verminderen.',
          ],
          listTitle: 'TYPEN:',
          bullets: [
            'Lossy compressie: de afbeeldingsgrootte wordt verkleind door een deel van de gegevens te verwijderen. De kwaliteit kan dalen, maar vaak is dit niet direct met het blote oog te zien.',
            'Lossless compressie: verkleint de bestandsgrootte zonder de visuele kwaliteit van de afbeelding aan te tasten.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Waarom kiezen voor onze tool?',
          bullets: [
            'Onze AI-aangedreven afbeeldingscompressor werkt soepel op alle apparaten en levert de best mogelijke resultaten.',
            'Je kunt meerdere afbeeldingen tegelijk comprimeren (zelfs 100+) met slechts één klik.',
            'Je hoeft je afbeeldingen niet naar onze servers te uploaden. Alles wordt lokaal in je browser verwerkt.',
            'Onze afbeeldingscompressor is volledig gratis voor altijd. Je kunt deze tool ook delen met je vrienden.',
            'Je kunt het compressiepercentage kiezen op basis van je voorkeur.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Stapsgewijze handleiding',
          steps: [
            {
              heading: '1. Selecteer de afbeelding(en) die je wilt comprimeren.',
              bullets: [
                'Sleep de afbeelding(en) naar het uploadvak.',
                'Je kunt ook afbeeldingen kopiëren en plakken in het vak via (Ctrl + V).',
                'Bestandsverkenner wordt ook ondersteund via de kiesknop.',
              ],
            },
            {
              heading: '2. Kies daarna het compressiepercentage.',
              bullets: [
                'Met de horizontale schuifbalk kun je comfortabel het compressiepercentage kiezen. Volg deze bereiken voor nauwkeurige resultaten.',
              ],
              table: {
                headers: ['Compressiepercentage', 'Resultaat'],
                rows: [
                  ['1%  tot  40%', 'Beste kwaliteit'],
                  ['41%  tot  60%', 'Normale kwaliteit (Aanbevolen)'],
                  ['61%  tot  100%', 'Lage kwaliteit'],
                ],
              },
            },
            {
              heading: '3. Bekijk hoeveel opslagruimte je hebt bespaard.',
              paragraphs: [
                'Alle grootte-indicatoren worden in real-time weergegeven. Zo zie je duidelijk hoeveel ruimte je hebt bespaard en kun je het compressieniveau aanpassen aan je gewenste bestandsgrootte.',
              ],
            },
            {
              heading: '4. Kies de downloadoptie via de schakelknop.',
              bullets: [
                'ZIP: als je meerdere afbeeldingen comprimeert, zie je deze optie. Hiermee worden alle gecomprimeerde afbeeldingen in één ZIP-bestand gezet (aanbevolen voor veel afbeeldingen).',
                'Apart: met deze optie worden alle afbeeldingen afzonderlijk gedownload en niet als één ZIP-bestand (aanbevolen voor kleine aantallen, minder dan 10).',
              ],
            },
            {
              heading: '5. Comprimeer en download de afbeelding.',
              paragraphs: [
                'Deze knop downloadt automatisch alle gecomprimeerde afbeeldingen volgens de door jou gekozen downloadoptie.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Voordelen van een afbeeldingscompressor.',
          bullets: [
            'Lagere opslagkosten: gecomprimeerde afbeeldingen nemen aanzienlijk minder ruimte in.',
            'Snellere laadtijd: gecomprimeerde afbeeldingen laden sneller en verbeteren de gebruikerservaring.',
            'Oplossing voor Gmail-limiet: omdat Gmail bijlagen beperkt tot 25MB, helpt compressie om meer bestanden te verzenden.',
            'Sneller delen en overdragen: grote bestanden kosten meer tijd om te versturen; compressie bespaart tijd en data.',
            'Presentatie-optimalisatie: ongecomprimeerde afbeeldingen maken presentaties zwaar, terwijl gecomprimeerde afbeeldingen de totale bestandsgrootte sterk verlagen.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Ondersteunde formaten.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Afbeeldingsconverter — Converteer PNG, JPG, WEBP, GIF, SVG Gratis | photremium.com',
      uploadDesc: 'Converteer afbeeldingen tussen JPG, PNG, WEBP, GIF, SVG, TIFF en BMP. Gratis online afbeeldingsformaatconverter.',
      uploadKeywords: 'afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',
      workspaceKeywords: 'afbeeldingen converteren, afbeeldingsformaatconverter',

      routeKeywords: {

        'png-to-jpg': 'png te converteren jpg, png to jpg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'jpg-to-png': 'jpg te converteren png, jpg to png, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'png-to-webp': 'png te converteren webp, png to webp, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'jpg-to-webp': 'jpg te converteren webp, jpg to webp, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'webp-to-jpg': 'webp te converteren jpg, webp to jpg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'webp-to-png': 'webp te converteren png, webp to png, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'gif-to-jpg': 'gif te converteren jpg, gif to jpg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'gif-to-png': 'gif te converteren png, gif to png, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'bmp-to-jpg': 'bmp te converteren jpg, bmp to jpg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'bmp-to-png': 'bmp te converteren png, bmp to png, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'svg-to-png': 'svg te converteren png, svg to png, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'svg-to-jpg': 'svg te converteren jpg, svg to jpg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'tiff-to-jpg': 'tiff te converteren jpg, tiff to jpg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'tiff-to-png': 'tiff te converteren png, tiff to png, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'jpg-to-gif': 'jpg te converteren gif, jpg to gif, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'png-to-gif': 'png te converteren gif, png to gif, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'jpg-to-bmp': 'jpg te converteren bmp, jpg to bmp, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'png-to-bmp': 'png te converteren bmp, png to bmp, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'webp-to-gif': 'webp te converteren gif, webp to gif, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'jpg-to-ico': 'jpg te converteren ico, jpg to ico, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'png-to-ico': 'png te converteren ico, png to ico, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'jpg-to-svg': 'jpg te converteren svg, jpg to svg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'png-to-svg': 'png te converteren svg, png to svg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'webp-to-svg': 'webp te converteren svg, webp to svg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'gif-to-svg': 'gif te converteren svg, gif to svg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'bmp-to-svg': 'bmp te converteren svg, bmp to svg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

        'tiff-to-svg': 'tiff te converteren svg, tiff to svg, afbeeldingsconverter, png naar jpg, jpg naar png, webp converter',

      },
    },
    title: 'Afbeeldingsconverter',
    desc: 'Converteer afbeeldingen tussen JPG, PNG, WEBP, GIF, SVG, TIFF en BMP. Batchconversie van meerdere bestanden.',
    toConvert: 'te converteren',
    convertSettings: 'Conversie-instellingen',
    detected: 'Gedetecteerd',
    convertTo: 'Converteren naar',
    converting: 'Converteren…',
    convertToFormat: 'Converteren naar {format}',
    popularConversions: 'Populaire Conversies',
    convertingTo: 'Converteren naar',
    all: 'Alle',
  },

  resizer: {
    seo: {
      uploadTitle: 'Formaat Afbeelding Wijzigen — JPG, PNG Gratis Vergroten/Verkleinen | photremium.com',
      uploadDesc: 'Verander afbeeldingsformaat in pixels of procenten gratis online.',
      uploadKeywords: 'formaat afbeelding wijzigen, formaat wijzigen tool, jpg formaat wijzigen, png formaat wijzigen',
      workspaceTitle: 'Afbeeldingsformaat Wijzigen — photremium.com',
      workspaceDesc: 'Verander afbeeldingsformaat gratis online.',
      workspaceKeywords: 'formaat afbeelding wijzigen, formaat wijzigen tool',
    },
    title: 'Formaat Afbeelding Wijzigen',
    desc: 'Geef een grootte op in pixels, procenten, centimeters of inches en verander het formaat direct.',
    toResize: 'te vergroten/verkleinen',
    resizeSettings: 'Formaatinstellingen',
    resizeBy: 'Formaat wijzigen op:',
    byPixels: 'Pixels',
    byPercentage: 'Percentage',
    byCentimeters: 'Centimeters',
    byInches: 'Inches',
    advanced: 'Geavanceerd',
    lockAspect: 'Beeldverhouding Vergrendelen',
    unlockAspect: 'Beeldverhouding Ontgrendelen',
    dontEnlarge: 'Niet vergroten als origineel kleiner is',
    resizing: 'Formaat wijzigen…',
    resizeDownload: 'Formaat Wijzigen en Downloaden',
    blog: {
      tocTitle: 'Inhoudsopgave',
      title: 'Blog over Afbeelding Formaat Wijzigen',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Waarom een afbeelding-resizer gebruiken?',
          paragraphs: [
            'Een afbeelding-resizer is een tool/software om de afmetingen van een afbeelding te wijzigen. U kunt hoogte, breedte of beide aanpassen om de gewenste grootte te krijgen. Dit is vooral handig voor socialmediaplatforms met upload-/postlimieten voor afbeeldingen.',
          ],
          listTitle: 'Bijvoorbeeld:',
          bullets: [
            'Instagram-post: 1080 x 1080px (vierkant)',
            'Facebook-post: 1200 x 630px',
            'X (Twitter)-post: 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Waarom kiezen voor onze afbeelding-resizer?',
          paragraphs: [
            'Onze AI-afbeelding-resizer laat u afbeeldingen zeer nauwkeurig en snel schalen. De tool werkt soepel op elk apparaat en vereist geen installatie. Alle functies zijn online beschikbaar in uw browser.',
          ],
          bullets: [
            'U kunt meerdere afbeeldingen tegelijk schalen (zelfs 100+). Met een krachtig apparaat kunt u zelfs 400–500 afbeeldingen in enkele seconden verwerken.',
            'Alles wordt lokaal in uw browser verwerkt. U hoeft niets naar onze server te uploaden, dus uw afbeeldingen verlaten uw apparaat niet.',
            'Meerdere resize-eenheden worden ondersteund.',
            'U kunt de beeldverhouding behouden met één selectievakje.',
            'Bij meerdere afbeeldingen kunt u afzonderlijk downloaden of als ZIP-bestand.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Stapsgewijze handleiding',
          steps: [
            {
              heading: 'Selecteer eerst de afbeelding(en) die u wilt schalen. Er zijn meerdere manieren om te selecteren.',
              bullets: [
                'Sleep afbeeldingen naar het dropvak om ze te schalen.',
                'U kunt ook plakken met de sneltoets “Ctrl + V”.',
                'Of klik op “Choose Files” om afbeeldingen via Verkenner te selecteren.',
              ],
            },
            {
              heading: 'Kies daarna een resize-eenheid. Beschikbare eenheden zijn:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Pas vervolgens hoogte en breedte aan. U kunt de beeldverhouding ook vergrendelen via het selectievakje.',
            },
            {
              heading: 'Als u niet wilt vergroten boven de originele grootte, vink dan “Don’t enlarge if original is smaller” aan.',
            },
            {
              heading: 'Kies daarna een downloadoptie.',
              bullets: [
                'Kies ZIP als u alle geschaalde afbeeldingen in één zipbestand wilt.',
                'Kies “separate” als u elke afbeelding apart wilt downloaden.',
              ],
            },
            {
              heading: 'Klik tenslotte op “Resize & Download” om te downloaden volgens de gekozen optie.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Voordelen van een afbeelding-resizer: het grootste voordeel is dat afbeeldingen correct passen op webpagina’s en socialmediaposts.',
          tocLabel: '4. Voordelen van een afbeelding-resizer',
          bullets: [
            'Betere UX: juiste afmetingen en plaatsing verbeteren de gebruikerservaring sterk.',
            'Socialmedia-compatibel: veel platforms hebben vaste afbeeldingsmaten; onze tool helpt daarbij.',
            'Responsief ontwerp: ontwikkelaars hebben meerdere afbeeldingsmaten nodig voor verschillende apparaten.',
            'Beste keuze: in plaats van uitrekken of hard croppen (wat de verhouding kan breken) is resizen vaak beter.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Ondersteunde formaten: onze afbeelding-resizer ondersteunt selectie van afbeeldingen in elk formaat. Ondersteunde formaten:',
          tocLabel: '5. Ondersteunde formaten',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Afbeelding Bijsnijden — JPG, PNG, GIF Gratis Bijsnijden | photremium.com',
      uploadDesc: 'Snijd eenvoudig JPG, PNG en GIF afbeeldingen gratis online bij.',
      uploadKeywords: 'afbeelding bijsnijden, bijsnijden tool, jpg bijsnijden, png bijsnijden',
      workspaceTitle: 'Afbeelding Bijsnijden — photremium.com',
      workspaceDesc: 'Snijd afbeeldingen gratis online bij.',
      workspaceKeywords: 'afbeelding bijsnijden, bijsnijden tool',
    },
    title: 'Afbeelding Bijsnijden',
    desc: 'Snijd JPG, PNG, GIF en andere bij met een visuele editor. Vooraf ingestelde of vrije beeldverhoudingen.',
    toCrop: 'bij te snijden',
    cropSettings: 'Bijsnijdinstellingen',
    widthPx: 'Breedte (px)',
    heightPx: 'Hoogte (px)',
    positionX: 'Positie X (px)',
    positionY: 'Positie Y (px)',
    cropTemplate: 'Bijsnijsjabloon',
    landscape: 'Liggend',
    portrait: 'Staand',
    square: 'Vierkant',
    freeform: 'Vrij',
    cropping: 'Bijsnijden…',
    cropDownload: 'Bijsnijden en Downloaden',
    cropDownloadAll: 'Bijsnijden en Alles Downloaden',
    saveNext: 'Opslaan en Volgende',
    croppedNofTotal: '{n} van {total} bijgesneden.',
    downloadN: '{n} Downloaden',
    blog: {
      tocTitle: 'Inhoudsopgave',
      title: 'Blog over Afbeeldingen Bijsnijden',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Waarom een afbeelding-bijsnijder gebruiken?',
          paragraphs: [
            'Een afbeelding-bijsnijder is een softwaretool die wordt gebruikt om een afbeelding in de gewenste vorm bij te snijden. Deze wordt veel gebruikt om het benodigde deel van de afbeelding te behouden en ongewenste buitenranden te verwijderen voor elk doel. De tool biedt een bijsnijkader dat u kunt aanpassen op de positie die u wilt bijsnijden.',
          ],
          listTitle: 'Bijvoorbeeld:',
          bullets: [
            'Uzelf uit een groepsfoto bijsnijden.',
            'Uw naam uit een lijst bijsnijden.',
            'De voortgangsbalk uit een volledige schermafbeelding bijsnijden.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Waarom kiezen voor onze afbeelding-bijsnijder?',
          paragraphs: [
            'Met onze afbeelding-bijsnijder kunt u afbeeldingen zeer nauwkeurig en snel bijsnijden. U hoeft alleen de grootte van het bijsnijkader aan te passen op de positie die u wilt bijsnijden op elke afbeelding. Bij het selecteren van afbeeldingen worden vrijwel alle afbeeldingsformaten ondersteund.',
          ],
          bullets: [
            'U kunt zoveel afbeeldingen bijsnijden als uw apparaat ondersteunt. Als u een krachtig apparaat heeft, kunt u zelfs 100+ afbeeldingen tegelijk bijsnijden zonder vertraging of andere problemen.',
            'Uw afbeeldingen worden verwerkt in uw lokale browser. U hoeft geen afbeeldingen naar onze server te uploaden, dus geen enkele afbeelding verlaat uw apparaat. U kunt persoonlijke afbeeldingen bijsnijden zonder beveiligingsrisico’s.',
            'Veel tools geven de fout “ongeldig afbeeldingsformaat”. Onze bijsnijtool lost dit op door vrijwel alle afbeeldingsformaten te ondersteunen.',
            'Als u veel afbeeldingen tegelijk bijsnijdt, kunt u met onze tool de bijgesneden afbeeldingen als ZIP of afzonderlijk downloaden, afhankelijk van uw voorkeur.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Stapsgewijze handleiding',
          steps: [
            {
              heading: '1. Selecteer eerst de afbeelding die u wilt bijsnijden. Onze bijsnijtool ondersteunt ook het selecteren van meerdere afbeeldingen tegelijk.',
              bullets: [
                'Sleep afbeeldingen naar het dropvak om ze bij te snijden.',
                'U kunt ook afbeeldingen selecteren via de bestandsverkenner door op de knop choose files in het bijsnijkader te klikken.',
                'Sneltoets Ctrl + V wordt ook ondersteund om afbeeldingen in het dropvak te plakken.',
              ],
            },
            {
              heading: '2. Pas daarna de grootte en positie van het bijsnijkader op de afbeelding aan.',
            },
            {
              heading: '3. U kunt het bijsnijkader ook handmatig aanpassen door hoogte, breedte, horizontale positie en verticale positie in te voeren.',
            },
            {
              heading: '4. U kunt ook enkele kant-en-klare sjablonen gebruiken:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Kies daarna een van de downloadopties.',
              bullets: [
                'ZIP: kies deze optie als u veel afbeeldingen bijsnijdt en alle bijgesneden afbeeldingen als één bestand wilt downloaden.',
                'Separate: als u alle bijgesneden afbeeldingen afzonderlijk wilt downloaden, kiest u deze optie via de schakelknop.',
              ],
            },
            {
              heading: '6. Klik daarna op de knop Crop & Download om al uw bijgesneden afbeeldingen te downloaden volgens uw vooraf ingestelde afmetingen.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Voordelen van afbeeldingen bijsnijden: een afbeelding-bijsnijder biedt verschillende voordelen in de digitale wereld. Enkele daarvan staan hieronder:',
          tocLabel: '4. Voordelen van afbeeldingen bijsnijden',
          bullets: [
            'Afbeeldingen in een kader passen: een bijsnijtool helpt u om een afbeelding correct in een kader te plaatsen. Dat kader kan op een webpagina of op een socialmediaplatform staan.',
            'UX verbeteren: omdat juiste plaatsing van afbeeldingen de gebruikerservaring verbetert, helpt bijsnijden sterk bij het verbeteren van UX.',
            'Ongewenste randen verwijderen: u kunt ongewenste randen uit een afbeelding verwijderen om deze netter te maken.',
            'Gewenst object isoleren: u kunt uzelf ook uit een groepsfoto isoleren.',
            'Opslag besparen: bijsnijden bespaart opslag omdat het overbodige deel van de afbeelding wordt verwijderd en alleen het gewenste deel overblijft.',
            'Presentaties optimaliseren: een normale presentatie met 10 ongesneden afbeeldingen gebruikt ongeveer 30MB opslag; dezelfde presentatie met bijgesneden afbeeldingen kan ongeveer 10MB gebruiken.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Ondersteunde formaten:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Online Fotobewerker — Gratis Bewerken met Tekst, Effecten, Frames | photremium.com',
      desc: 'Bewerk foto\'s online gratis — voeg tekst, effecten, frames, stickers toe. Werkt in de browser.',
      keywords: 'fotobewerker, online fotobewerker, foto\'s online gratis bewerken',
    },
    title: 'Fotobewerker',
    desc: 'Verbeter uw foto\'s met tekst, effecten, frames en stickers.',
    toEdit: 'te bewerken',
    textTypography: 'Tekst en Typografie',
    textTypographyDesc: 'Voeg tekst toe met verschillende lettertypen, kleuren, schaduwen en posities.',
    filtersEffects: 'Filters en Effecten',
    filtersEffectsDesc: 'Pas professionele filters toe en pas helderheid, contrast en verzadiging aan.',
    framesStickers: 'Frames en Stickers',
    framesStickersDesc: 'Kies mooie frames en leuke stickers om uw afbeeldingen te verfraaien.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Gratis Afbeeldingsachtergrond Verwijderen | photremium.com',
      uploadDesc: 'Verwijder afbeeldingsachtergronden snel met hoge nauwkeurigheid. Gratis online tool.',
      uploadKeywords: 'achtergrond verwijderen, achtergrondverwijdering, afbeelding achtergrond verwijderen, transparante achtergrond',
      workspaceTitle: 'Achtergrond Verwijderen — photremium.com',
      workspaceDesc: 'Verwijder afbeeldingsachtergrond gratis online.',
      workspaceKeywords: 'achtergrond verwijderen, transparante achtergrond',
    },
    title: 'Achtergrond Verwijderen',
    desc: 'Verwijder direct afbeeldingsachtergronden met geavanceerde randdetectie. 100% gratis, werkt in de browser.',
    toRemoveBg: 'achtergrond te verwijderen',
    backgroundRemover: 'Achtergrondverwijderingstool',
    processingProgress: 'Verwerkingsvoortgang',
    processingNImages: '{n} afbeeldingen verwerken…',
    allNProcessed: 'Alle {n} afbeeldingen verwerkt!',
    nOfTotalDone: '{n} / {total} gereed',
    fileName: 'Bestandsnaam',
    dimensions: 'Afmetingen',
    status: 'Status',
    statusDone: '✓ Gereed',
    statusProcessing: '⏳ Verwerken',
    statusError: '✗ Fout',
    statusPending: '⏸ In afwachting',
    badgeDone: 'Gereed',
    badgeProcessing: 'Verwerken…',
    badgeError: 'Fout',
    removingBg: 'Achtergrond verwijderen…',
    retry: 'Opnieuw',
    downloading: 'Downloaden…',
    nextImage: 'Volgende Afbeelding',
  },

  watermark: {
    seo: {
      uploadTitle: 'Afbeelding Watermerken — Tekst- en Logo Watermerk Gratis Toevoegen | photremium.com',
      uploadDesc: 'Voeg tekst- of afbeeldingswatermerken toe aan foto\'s in seconden. Gratis, snel.',
      uploadKeywords: 'afbeelding watermerken, watermerk toevoegen, tekst watermerk',
      workspaceTitle: 'Afbeelding Watermerken — photremium.com',
      workspaceDesc: 'Voeg watermerken toe aan afbeeldingen gratis online.',
      workspaceKeywords: 'afbeelding watermerken, watermerk toevoegen',
    },
    title: 'Afbeelding Watermerken',
    desc: 'Voeg tekst- of logowatermerken toe aan afbeeldingen. Pas lettertype, dekking, grootte en positie aan.',
    toWatermark: 'watermerken toe te voegen',
    watermarkTools: 'Watermerktools',
    addText: 'Tekst Toevoegen',
    addImage: 'Afbeelding Toevoegen',
    layersN: 'Lagen ({n})',
    noLayers: 'Nog geen lagen toegevoegd',
    textLayer: 'Tekstlaag',
    imageLayer: 'Afbeeldingslaag',
    watermarkDownloadAll: 'Watermerk Toevoegen en Alles Downloaden',
    watermarkDownload: 'Watermerk Toevoegen en Downloaden',
    nextImage: 'Volgende Afbeelding',
    selectToEdit: 'Selecteer een afbeelding of tekst om te beginnen met bewerken',
    bold: 'Vet',
    italic: 'Cursief',
    underline: 'Onderstrepen',
    bgColor: 'Achtergrondkleur',
    textColor: 'Tekstkleur',
    alignLeft: 'Links Uitlijnen',
    alignCenter: 'Centreren',
    alignRight: 'Rechts Uitlijnen',
    opacity: 'Dekking',
    stroke: 'Omtrek',
    strokeWidth: 'Omtrekbreedte',
    strokeColor: 'Omtrekkleur',
    tileRepeat: 'Tegels/Herhalen',
    tilePattern: 'Tegelpatroon',
    spacing: 'Afstand',
    snapToCenter: 'Naar Midden Vergrendelen',
    duplicate: 'Dupliceren',
    delete: 'Verwijderen',
    flipHorizontal: 'Horizontaal Spiegelen',
    flipVertical: 'Verticaal Spiegelen',
    rotateLeft: 'Links Draaien',
    rotateRight: 'Rechts Draaien',
    cornerRadius: 'Hoekradius',
    borderStroke: 'Rand/Omtrek',
    borderWidth: 'Randbreedte',
    color: 'Kleur',
    style: 'Stijl',
    hide: 'Verbergen',
    show: 'Tonen',
    lock: 'Vergrendelen',
    unlock: 'Ontgrendelen',
    solid: 'Effen',
    dashed: 'Gestippeld',
    dotted: 'Gepunteerd',
    double: 'Dubbel',
    tileSingle: 'Enkelvoudig',
    tile2x2: '2×2 Raster',
    tile3x3: '3×3 Raster',
    removeAllConfirm: 'Alle afbeeldingen en watermerken verwijderen?',
    dimMismatch: 'Geüploade afbeeldingen hebben verschillende afmetingen. Gebruik afbeeldingen met dezelfde resolutie voor de beste resultaten.',
    clearBackground: 'Achtergrond Wissen',
    typeHere: 'Typ hier...',
    linkCorners: 'Hoeken Koppelen',
    separateCorners: 'Hoeken Scheiden',
    blog: {
      tocTitle: 'Inhoud',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Overzicht van de watermerkgereedschap',
          title: 'Hoe voeg je online een watermerk toe aan je afbeeldingen — de complete gids voor Photremium’s watermerkgereedschap',
          paragraphs: [
            'Je hebt net een prachtige foto bewerkt. Misschien is het een productfoto voor je winkel, een portret uit een klantensessie of een digitaal kunstwerk waaraan je uren hebt gesleuteld. En dan komt de vraag die elke maker uiteindelijk moet beantwoorden: hoe bescherm je het voordat je het deelt?',
            'Het antwoord waar de meeste professionals op uitkomen is een watermerk — en met goede reden. Een goed geplaatst watermerk werkt als een permanente handtekening op je werk, waardoor het herleidbaar, gebrandmerkt en aanzienlijk moeilijker te stelen is.',
            'Het probleem waar de meeste mensen tegenaan lopen is simpel: de online tools zijn ofwel te onhandig, zitten achter een abonnement, of produceren een zó zwaar watermerk dat het de afbeelding volledig verpest.',
            'Photremium’s Watermark Image-tool is gebouwd om dat allemaal op te lossen. Het is een volledig browsergebaseerde, gratis, accountloze watermerk-werkruimte die rechtstreeks in je browser draait zonder je bestanden ooit naar een server te uploaden. Alles blijft lokaal, alles blijft snel en het niveau van creatieve controle is vergelijkbaar met wat je van desktopsoftware zou verwachten. In deze gids laten we precies zien hoe het werkt, voor wie het is gemaakt en hoe je telkens weer de beste resultaten behaalt.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Wat is een watermerk',
          title: 'Wat is een watermerk en waarom is het belangrijk?',
          paragraphs: [
            'Voordat we in de tool zelf duiken, is het nuttig om te begrijpen wat een watermerk doet en waarom zoveel fotografen, ontwerpers en contentmakers het onmisbaar vinden.',
            'Een watermerk is een zichtbare overlay die aan een afbeelding wordt toegevoegd — meestal tekst, een logo of een copyrightsymbool — en die de maker of eigenaar van de inhoud identificeert. In tegenstelling tot metadata (die verborgen in het bestand zitten en in enkele seconden kunnen worden verwijderd) is een watermerk visueel in de afbeelding zelf ingebed. Je kunt het niet zomaar met een rechtermuisklik verwijderen zonder de beeldkwaliteit merkbaar aan te tasten.',
          ],
          subSections: [
            {
              title: 'Waarom makers watermerken gebruiken',
              paragraphs: [
                'De praktische redenen om je afbeeldingen van een watermerk te voorzien komen neer op drie kernpunten.',
              ],
              bullets: [
                'Eigendom identificeren. Wanneer je werk wordt gedeeld op sociale media, Pinterest-borden of wordt ingebed in blogposts, raakt de oorspronkelijke bronvermelding vaak kwijt. Een watermerk zorgt ervoor dat je naam of merk met de afbeelding meereist, waar die ook belandt.',
                'Diefstal ontmoedigen. De meeste gelegenheidsdieven van afbeeldingen zoeken de weg van de minste weerstand. Een professioneel ogend watermerk, vooral wanneer het goed gepositioneerd en licht transparant is, geeft een duidelijk signaal: deze afbeelding behoort toe aan iemand die om zijn werk geeft.',
                'Bescherming van klantportfolio’s. Fotografen die previews delen met klanten vóór de eindbetaling, gebruiken vaak watermerken om te voorkomen dat klanten de preview gebruiken zonder de factuur te voldoen. Een subtiel watermerk bereikt dit zonder de preview te veel af te leiden.',
              ],
            },
            {
              title: 'Wie zou zijn afbeeldingen van een watermerk moeten voorzien',
              paragraphs: [
                'Als je in een van de volgende categorieën valt, is het niet optioneel om je afbeeldingen vóór het online delen van een watermerk te voorzien — het is essentieel:',
              ],
              bullets: [
                'Freelance fotografen die galerijen delen met klanten',
                'Grafisch ontwerpers die portfoliosamples verspreiden',
                'E-commerceverkopers die productfoto’s tonen vóór licentieafspraken',
                'Digitale kunstenaars die hun werk delen op sociale platforms',
                'Bloggers en contentmakers van wie afbeeldingen regelmatig opnieuw worden gebruikt',
                'Stockfotobijdragers die een herkenbaar merk opbouwen',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Werkruimtepanelen',
          title: 'Binnen Photremium’s watermerkgereedschap: een werkruimte met drie panelen, gebouwd voor echte workflows',
          paragraphs: [
            'Wat de watermerktool van Photremium onderscheidt van eenvoudige online watermerk-tools is het werkruimteontwerp. In plaats van een simpele “typ tekst, kies positie, klaar”-aanpak, biedt de tool een indeling met drie panelen die doet denken aan professionele ontwerpsoftware — behalve dat het volledig in je browser draait, zonder installatie.',
          ],
          subSections: [
            {
              title: 'Het linker canvaspaneel',
              paragraphs: [
                'Het canvaspaneel neemt het grootste deel van het scherm in beslag en laat je precies zien hoe je afbeelding eruitziet met het watermerk in realtime toegepast. Elke wijziging die je aanbrengt — de dekking aanpassen, een tekstlaag verplaatsen, een logo schalen — zie je direct op het canvas. Er is geen knop “preview” om op te klikken. Wat je ziet is wat je krijgt.',
                'Het canvas bevat ook een ingebouwde zoomwerkbalk, zodat je kunt inzoomen voor precieze uitlijning en uitzoomen voor het grotere geheel. De functie zoom-to-fit berekent automatisch de beste beginschaal op basis van je schermgrootte, zodat zelfs hoge-resolutie afbeeldingen op een comfortabele werkmaat worden geladen. Uitlijningshulplijnen verschijnen dynamisch wanneer je een laag dicht bij het horizontale of verticale midden van de afbeelding sleept, waardoor het watermerk met een bevredigende precisie precies gecentreerd wordt — iets wat je normaal alleen uit Photoshop zou verwachten.',
              ],
            },
            {
              title: 'Het rechter instellingenpaneel',
              paragraphs: [
                'Het rechterpaneel is het controlecentrum. Hier beheer je je watermerklagen, pas je hun uiterlijk aan en start je de uiteindelijke export. Op desktop staat het vast aan de rechterkant van het scherm. Op mobiele apparaten schuift het omhoog als een bottom sheet — aangestuurd door een zwevende tandwielknop — zodat het je canvas nooit bedekt terwijl je werkt.',
                'Binnen het rechterpaneel vind je de lagenbeheerder, die elk toegevoegd watermerkelement opsomt. Elke laagregel toont het type laag (tekst of afbeelding), de huidige naam of inhoud, en drie snelle actieknoppen: een zichtbaarheidsschakelaar (het oog-icoon), een vergrendelschakelaar om een laag op zijn plek te houden terwijl je aan andere lagen werkt, en een verwijderknop.',
              ],
            },
            {
              title: 'De linkse previewstrook (meerdere afbeeldingen)',
              paragraphs: [
                'Wanneer je met meerdere afbeeldingen tegelijk werkt — een batch productfoto’s, een complete portretsessie — verschijnt er uiterst links een verticale miniatuurstrook. Dat is de afbeeldingsrij, met verkleinde previews van elk bestand dat je hebt geladen. Door op een miniatuur te klikken schakel je je canvas direct naar die afbeelding, zodat je kunt controleren hoe het watermerk eruitziet in verschillende composities zonder je laaginstellingen te verliezen.',
                'De strook toont ook de bestandsgrootte in KB of MB, plus het bestandsformaatlabel (JPG, PNG, WEBP), zodat je in één oogopslag weet waarmee je werkt.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Stap voor stap',
          title: 'Stap voor stap: hoe je een watermerk toevoegt aan je afbeelding in Photremium',
          paragraphs: [
            'Deze uitleg is rechtstreeks gebaseerd op hoe de tool onder de motorkap werkt — van het uploaden via slepen en neerzetten tot de canvas-renderengine die je watermerk permanent op de afbeelding schrijft vóór het downloaden.',
          ],
          steps: [
            {
              heading: 'Stap 1 — Upload je afbeelding(en)',
              paragraphsBefore: [
                'Ga naar photremium.com/watermark-image. Je komt op het uploadscherm terecht, met een nette drag-and-dropzone in het midden van de pagina.',
                'Je hebt drie manieren om je afbeelding in de tool te krijgen:',
              ],
              bullets: [
                'Slepen en neerzetten. Sleep een of meer afbeeldingsbestanden vanaf je bureaublad rechtstreeks naar de dropzone. De tool accepteert elk standaard afbeeldingsformaat — JPEG, PNG, WEBP en meer. Wanneer je bestanden over de werkruimte sleept, activeert er een paarse rand rond het hele gebied met de visuele melding “Drop images to add for watermarking”, zodat je weet dat het neerzetten wordt geregistreerd.',
                'Klik om te bladeren. Klik op de knop “Choose Files” in de dropzone om de bestandskiezer van je systeem te openen. Je kunt meerdere bestanden tegelijk selecteren met Ctrl+Click (Windows) of Cmd+Click (Mac).',
                'Plakken vanuit het klembord. Als je een afbeelding naar je klembord hebt gekopieerd — vanuit een screenshot, een andere app of een webbrowser — druk dan gewoon op Ctrl+V (of Cmd+V op Mac) terwijl je op de watermarkpagina bent en de afbeelding wordt direct in de werkruimte geladen. Dit werkt zelfs wanneer er al meerdere afbeeldingen zijn geladen.',
              ],
              paragraphsAfter: [
                'Zodra de eerste afbeelding is geladen, schakelt de werkruimte over van het uploadscherm naar de volledige driepanelen-editor, en het canvas toont je afbeelding op een automatisch berekend zoomniveau dat op het scherm past.',
              ],
            },
            {
              heading: 'Stap 2 — Voeg een tekst-watermerklag toe',
              paragraphsBefore: [
                'Klik op de paarse knop “Add Text” in het rechterpaneel. Er verschijnt een nieuwe tekstlaag op je canvas met de standaard placeholdertekst “Type here...” al geselecteerd.',
                'Je kunt meteen beginnen te typen. De tekst wordt live op het canvas weergegeven in wit Arial, op een standaardgrootte die is afgestemd op de afmetingen van je afbeelding. Vanuit de bovenste werkbalk die verschijnt wanneer de tekstlaag is geselecteerd, kun je elk aspect van de tekst aanpassen:',
              ],
              bullets: [
                'Lettertypefamilie — kies uit 12 ingebouwde lettertypen, waaronder Arial, Georgia, Impact, Brush Script MT, Comic Sans MS en meer',
                'Lettergrootte — typ direct een aangepaste pixelwaarde of gebruik de stapknoppen',
                'Vet, cursief, onderstrepen — schakel elke combinatie van deze stijlen in',
                'Tekstkleur — klik op het kleurstaal om de kleurkiezer te openen en kies elke hexkleur',
                'Achtergrondkleur — voeg een gekleurde achtergrond achter je tekst toe voor een label- of badge-uiterlijk',
                'Lijn (outline) — stel een lijnbreedte en kleur in voor maximale leesbaarheid op lichte en donkere afbeeldingen',
                'Dekking — schuif van 0% (onzichtbaar) tot 100% (volledig ondoorzichtig); de meeste watermerken zitten tussen 30% en 60%',
                'Uitlijning — links, gecentreerd of rechts uitlijnen binnen het kader',
                'Rotatie — roteer de tekstlaag naar elke hoek, met magnetische snap-punten bij 0°, 90°, 180° en 270° voor snelle rechte plaatsing',
              ],
              paragraphsAfter: [
                'Om de tekst te verplaatsen, klik en sleep je hem naar elke gewenste plek op het canvas. Voor fijne pixel-nauwkeurige plaatsing gebruik je de pijltoetsen op je toetsenbord (houd Shift ingedrukt voor stappen van 10 pixels). Om het tekstvak te schalen, sleep je een van de acht resize-handles (hoeken en randen) die rond de geselecteerde laag verschijnen.',
              ],
            },
            {
              heading: 'Stap 3 — Voeg een afbeeldings- (logo) watermerklag toe',
              paragraphsBefore: [
                'Als je een logo, handtekening of elke andere afbeelding als watermerk wilt gebruiken in plaats van — of naast — tekst, klik dan op de blauwe knop “Add Image” in het rechterpaneel. Je bestandskiezer opent zodat je het watermerkafbeeldingsbestand van je apparaat kunt selecteren.',
                'De tool schaalt de watermerkafbeelding automatisch naar ongeveer 30% van de breedte van je canvas, met behoud van de oorspronkelijke beeldverhouding, en centreert deze op het canvas. Van daaruit kun je hem naar elke positie slepen, van formaat wijzigen met de hoekhandvatten (die de beeldverhouding behouden) of roteren met de speciale draaigreep die boven de geselecteerde laag verschijnt.',
                'Voor watermerklagen van het afbeeldingstype biedt het rechterpaneel extra instellingen:',
              ],
              bullets: [
                'Dekking — hetzelfde als bij tekstlagen, ideaal voor transparante PNG-logo’s',
                'Horizontaal spiegelen / Verticaal spiegelen — spiegel het watermerk indien nodig',
                'Randbreedte, randkleur en randstijl — voeg een zichtbare rand toe rond het logo-watermerk',
                'Randradius — rond de hoeken van het logo-watermerk af, uniform of per hoek afzonderlijk',
                'Rotatie — hetzelfde vloeiende rotatiegedrag als bij tekstlagen',
              ],
            },
            {
              heading: 'Stap 4 — Stel tiling in (optioneel)',
              paragraphsBefore: [
                'Een van de krachtigste functies in de tool is tiling — de mogelijkheid om je watermerk over de hele afbeelding in een rasterpatroon te herhalen. Dit is vooral handig wanneer je een afbeelding onbruikbaar wilt maken voor herpublicatie in plaats van alleen maar te brandmerken.',
                'Met een geselecteerde laag zoek je in de werkbalk naar de tile-optie. Je kunt deze instellen op:',
              ],
              bullets: [
                'Geen — enkele plaatsing (standaard)',
                '2×2 raster — herhaalt het watermerk in een patroon van 2 kolommen en 2 rijen',
                '3×3 raster — herhaalt in een 3×3 raster voor dichtere dekking',
              ],
              paragraphsAfter: [
                'Je kunt ook de tile-afstand aanpassen, wat de ruimte tussen elke herhaling bepaalt. Het canvas toont ghost-previews van alle getegelde kopieën, zodat je het volledige dekkingspatroon kunt zien voordat je downloadt.',
              ],
            },
            {
              heading: 'Stap 5 — Gebruik de lagenbeheerder voor meerdere watermerken',
              paragraphsBefore: [
                'Je kunt zoveel lagen toevoegen als je wilt — tekst- en afbeeldingswatermerken vrij combineren. De lagenbeheerder in het rechterpaneel toont ze allemaal. Je kunt:',
              ],
              bullets: [
                'Individuele lagen tonen/verbergen met het oog-icoon — handig om te wisselen tussen verschillende watermerkversies zonder iets te verwijderen',
                'Een laag vergrendelen om te voorkomen dat deze per ongeluk verschuift terwijl je aan andere lagen werkt',
                'Een laag permanent verwijderen',
              ],
              paragraphsAfter: [
                'Door op een laag in de lijst te klikken, selecteer je die ook direct op het canvas, zodat je gemakkelijk tussen lagen kunt schakelen zonder op de afbeelding te hoeven zoeken.',
              ],
            },
            {
              heading: 'Stap 6 — Wissel tussen meerdere afbeeldingen',
              paragraphsBefore: [
                'Als je meer dan één afbeelding hebt geüpload, gebruik dan de miniatuurstrook links om de actieve canvasafbeelding te wisselen. De watermerklagen die je hebt ingesteld, gelden universeel — ze worden bij export op elke afbeelding in je batch gerenderd.',
                'De tool voert ook een controle op resolutieconsistentie uit over je batch. Als je afbeeldingen aanzienlijk verschillende afmetingen hebben (meer dan 5% verschil in breedte of hoogte), verschijnt er een waarschuwing die aangeeft dat de watermerkpositie er per afbeelding anders uit kan zien door het verschil in grootte. De engine handelt dit soepel af via een proportioneel herplaatsingsalgoritme: hij berekent de watermerkpositie als percentage van de afmetingen van de referentieafbeelding en past dezelfde proportionele plaatsing toe op elke andere afbeelding in de batch, zodat de visuele intentie behouden blijft, zelfs bij verschillende resoluties.',
              ],
            },
            {
              heading: 'Stap 7 — Stel je downloadvoorkeuren in',
              paragraphsBefore: [
                'Voor opdrachten met één afbeelding klik je op de knop “Download” onder het canvas om de watermerkafbeelding direct op te slaan. De bestandsnaam wordt automatisch ingesteld op je oorspronkelijke bestandsnaam met “-watermarked” vóór de extensie. JPEG-afbeeldingen worden geëxporteerd op kwaliteit 0.95 — hoog genoeg om op normale weergavegroottes niet te onderscheiden te zijn van het origineel. PNG-afbeeldingen worden als verliesloze PNG geëxporteerd.',
                'Voor batchopdrachten (meerdere afbeeldingen) heb je twee downloadmodi die je in het rechterpaneel kunt kiezen:',
              ],
              bullets: [
                'ZIP-bestand — alle watermerkafbeeldingen worden verpakt in één ZIP-archief dat met één klik wordt gedownload. De tool laadt JSZip dynamisch om de compressie af te handelen.',
                'Losse bestanden — elke afbeelding wordt als een afzonderlijk bestand gedownload, met een korte pauze tussen elke download om browser-throttling te voorkomen.',
              ],
            },
            {
              heading: 'Stap 8 — Download en controleer',
              paragraphsBefore: [
                'Na het klikken op de downloadknop (of de knop “Watermark & Download All” voor batches) rendert de tool elke afbeelding op een verborgen HTML5 canvas-element op volledige native resolutie — niet op het verkleinde previewformaat dat je op het scherm ziet. Dat betekent dat de geëxporteerde afbeelding op 100% van de oorspronkelijke pixelafmetingen staat, met het watermerk op proportioneel juiste grootte getekend. Open het gedownloade bestand en zoom in om te controleren of de plaatsing en kwaliteit van het watermerk aan je verwachtingen voldoen.',
                'Ziet iets er niet goed uit, ga dan gewoon terug naar de werkruimte — je lagen zijn er nog steeds — pas aan en download opnieuw.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Pro-tips',
          title: 'Pro-tips voor de beste resultaten',
          bullets: [
            'Gebruik een semi-transparant PNG-logo voor een zo professioneel mogelijke uitstraling. Een logo-watermerk met een transparante achtergrond en 40–50% dekking ziet er veel verzorgder uit dan solide tekst. Exporteer je logo vanuit je ontwerptool als PNG met alfatransparantie voordat je het als afbeeldingslaag gebruikt.',
            'Plaats je watermerk op een plek waar het wegcroppen ervan waarde wegneemt. De rechteronderhoek is de meest voorkomende watermerkpositie — en de makkelijkste om weg te snijden. Voor sterkere bescherming kun je je watermerk over een visueel belangrijk deel van de afbeelding plaatsen, zoals over een gezicht, een productdetail of het focuspunt. De diagonale tile-optie is nog moeilijker te verwijderen zonder de afbeelding merkbaar te verslechteren.',
            'Gebruik de vergrendelfunctie wanneer je met meerdere lagen werkt. Zodra je tevreden bent met de primaire watermerkpositie, vergrendel je die laag voordat je secundaire lagen toevoegt. Zo voorkom je dat je hem per ongeluk verplaatst terwijl je aan andere elementen werkt.',
            'Test op lichte en donkere delen van je afbeelding. Een wit watermerk is onzichtbaar tegen een heldere lucht maar perfect leesbaar op een donkere schaduw. Voeg een subtiele lijn of achtergrondkleur toe om de leesbaarheid te garanderen, ongeacht wat er onder het watermerk zit.',
            'Sneltoetsen besparen altijd tijd. Pijltjestoetsen verplaatsen de geselecteerde laag één pixel tegelijk. Shift+Pijl verplaatst tien pixels per keer. De Delete-toets verwijdert de geselecteerde laag onmiddellijk. Deze sneltoetsen maken het fijnafstemmen van de plaatsing veel sneller dan slepen.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Privacy en veiligheid',
          title: 'Privacy en veiligheid: waarom browsergebaseerde verwerking belangrijk is',
          paragraphs: [
            'Een zorg die veel makers hebben bij online tools is waar hun afbeeldingen eigenlijk naartoe gaan. Bij servergebaseerde watermerkgereedschappen wordt je afbeelding geüpload naar de server van de aanbieder, daar verwerkt en vervolgens weer teruggestuurd. Dat betekent dat je ongepubliceerde werk, klantfoto’s of gevoelige productafbeeldingen door andermans infrastructuur gaan.',
            'Photremium’s watermerkgereedschap verwerkt alles lokaal in je browser. Je afbeeldingen worden in het geheugen van je apparaat geladen met behulp van de File API van de browser en worden nooit via internet verzonden. Het renderen van het watermerk gebeurt op een HTML5 canvas-element dat in JavaScript draait, volledig binnen je browsertab. Wanneer je de pagina sluit of op “Start Over” klikt, worden alle afbeeldingsgegevens uit het geheugen vrijgegeven en verwijderd. Er wordt niets opgeslagen buiten je eigen apparaat.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Eindsamenvatting',
          title: 'Waarom Photremium’s watermerkgereedschap een vaste plek in je reguliere workflow verdient',
          paragraphs: [
            'Er zijn tientallen watermerkgereedschappen online beschikbaar. Wat een tool de moeite waard maakt om te bookmarken in plaats van te vergeten, is meestal een combinatie van snelheid, controle en betrouwbaarheid.',
            'Snelheid is belangrijk omdat watermerken geen significante tijd aan je nabewerkingsworkflow zouden moeten toevoegen. Photremium laadt direct, verwerkt lokaal en exporteert binnen enkele seconden op volledige resolutie — zelfs bij grote batches. Er is geen server-side wachttijd, geen wachtrij en geen renderduur die oploopt met het aantal mensen dat tegelijkertijd online is.',
            'Controle is belangrijk omdat een verkeerd ogend watermerk erger is dan helemaal geen watermerk — het maakt je merk onprofessioneel. Het lagen-systeem, de per-eigenschapbediening in de werkbalk, de realtime canvas-preview en de ondersteuning voor sneltoetsen leveren samen een controleniveau op dat echt vergelijkbaar is met speciale desktopsoftware.',
            'Betrouwbaarheid is belangrijk omdat je ongepubliceerde werk waardevol is. Weten dat je afbeeldingen nooit via internet naar een derde server gaan, betekent dat je klantfoto’s, nog niet uitgebrachte productafbeeldingen en gevoelige creatieve werken kunt watermerken zonder zorgen over gegevensverwerking, serverinbreuken of beleidswijzigingen van een cloudprovider.',
            'Of je nu een snelle copyrightmelding toevoegt aan één foto of een hele shoot van 200 afbeeldingen verwerkt voordat je een klantengalerij deelt, de Watermark Image-tool van Photremium geeft je de middelen om het goed te doen — volledig gratis, volledig privé en met genoeg creatieve flexibiliteit om het watermerk te laten lijken alsof het bij de afbeelding hoort in plaats van er bovenop geplakt te zijn.',
            'Ga naar photremium.com/watermark-image en probeer het uit. Je eerste watermerkafbeelding is letterlijk dertig seconden verwijderd.',
            'Photremium biedt een reeks browsergebaseerde tools voor beeldbewerking en -verwerking. Alle tools draaien lokaal in je browser — je afbeeldingen blijven op je apparaat.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR-code Generator — Gratis Genereren en Aanpassen | photremium.com',
      inputDesc: 'Genereer aangepaste QR-codes voor URL, tekst, WiFi, contacten, e-mail en Google Maps.',
      inputKeywords: 'qr code generator, qr code maken, aangepaste qr code',
      customizeTitle: 'QR-code Aanpassen — photremium.com',
      customizeDesc: 'Pas de stijl, kleuren, frame en logo van uw QR-code aan. Downloaden als PNG, JPG, SVG, WEBP of PDF.',
      customizeKeywords: 'qr code aanpassen, qr code stijl',
    },
    title: 'QR-code Generator',
    desc: 'Genereer, pas aan en download QR-codes voor URL, tekst, WiFi, contacten, e-mail en kaarten.',
    generate: 'Genereren',
    scanQrCode: 'QR-code Scannen',
    tabUrl: 'Link / URL',
    tabText: 'Tekst',
    tabWifi: 'WiFi',
    tabContact: 'Contact',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'URL invoeren',
    enterText: 'Tekst invoeren',
    networkName: 'Netwerknaam (SSID)',
    password: 'Wachtwoord',
    encryption: 'Versleuteling',
    hiddenNetwork: 'Verborgen Netwerk',
    contactName: 'Contactnaam (optioneel)',
    phoneNumber: 'Telefoonnummer',
    emailAddress: 'E-mailadres',
    subject: 'Onderwerp (optioneel)',
    body: 'Berichttekst (optioneel)',
    searchLocation: 'Locatie zoeken',
    urlPlaceholder: 'https://voorbeeld.nl',
    textPlaceholder: 'Voer hier tekst in…',
    wifiNamePlaceholder: 'Mijn WiFi',
    passwordPlaceholder: 'wachtwoord',
    contactPlaceholder: 'Jan de Vries',
    phonePlaceholder: '+31 6 12345678',
    emailPlaceholder: 'voorbeeld@gmail.com',
    subjectPlaceholder: 'onderwerp',
    bodyPlaceholder: 'berichttekst…',
    locationPlaceholder: 'Zoek stad, adres, locatie…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Geen',
    characters: 'tekens',
    generateCustomize: 'Genereren en Aanpassen',
    editQrData: 'QR-gegevens Bewerken',
    styleShape: 'Stijl en Vorm',
    colorTab: 'Kleuren',
    framesTab: 'Frames',
    logoTab: 'Logo',
    templatesTab: 'Sjablonen',
    fileFormatTab: 'Bestandsformaat',
    fgColor: 'Voorgrondkleur',
    bgColor: 'Achtergrondkleur',
    enableGradient: 'Kleurverloop Inschakelen',
    gradientType: 'Type Kleurverloop',
    linear: 'Lineair',
    radial: 'Radiaal',
    selectFrame: 'Frame Selecteren',
    selectLogo: 'Logo Selecteren',
    uploadCustomLogo: 'of uw eigen logo uploaden',
    uploadImage: 'Afbeelding Uploaden',
    downloadFormat: 'Downloadformaat',
    preview: 'Voorbeeld',
    downloadFormatBtn: '{format} Downloaden',
    pngDesc: 'Verliesvrij, ondersteunt transparantie',
    jpgDesc: 'Populair/universeel bestandsformaat',
    webpDesc: 'Modern formaat, beste kwaliteit/grootte',
    svgDesc: 'Schaalbare vectorafbeelding',
    pdfDesc: 'Klaar-om-te-printen document',
    lat: 'Breedte:',
    lng: 'Lengte:',
    qrCode: 'QR-code',
    scanMe: 'Scan Mij',
    scanHere: 'Scan Hier',
    blog: {
      card1: {
        title: '1. Wat is een QR-code?',
        intro1: '"QR-code" staat voor "Quick Response code". Omdat de informatie erin zeer snel wordt gedecodeerd, wordt het Quick Response (QR) code genoemd.',
        intro2: 'Een QR-code is een tweedimensionale digitale code die alleen door machines kan worden gelezen. De gegevens erin kunnen niet door mensen worden gelezen. Het bevat blokken om informatie op te slaan, zoals tekst, telefoonnummers, links en Google Maps-locaties, enz.',
        inventionTitle: 'Hoe de QR-code is uitgevonden:',
        inventionText: 'De QR-code werd in 1994 uitgevonden. Masahiro Hara en zijn team werkten in een Japans bedrijf genaamd Denso Wave, dat onderdelen voor auto\'s van Toyota maakte. Ze wilden een code die veel meer informatie opslaat dan een normale barcode, en zo uitvonden ze de QR-code.',
        keyFeaturesTitle: 'Belangrijkste kenmerken van een QR-code',
        keyFeatures: [
          {
            title: 'Hoe QR werkt',
            text: 'Je voert de tekst of link in om er een QR-code van te genereren. De QR-generator maakt vierkante vakken volgens de informatie. Elk vakje vertegenwoordigt een bit, en elke bit slaat een karakter op.',
          },
          {
            title: 'Structuur van QR-code',
            text: 'Een QR-code bevat drie grote vierkante vakken om de oriëntatie van de QR-code te identificeren, en een klein vierkant vakje om de bits (informatie) op te slaan.',
          },
          {
            title: 'Gegevenskapaciteit van QR-code',
            text: 'Meestal slaat een QR-code meer informatie op dan een barcode. Een QR-code is eenvoudig een geavanceerde versie van een barcode. Het is in feite een tweedimensionale barcode. Een QR-code slaat bijna 200 tekens op. Het kan ook 400 tekens opslaan, maar kan moeilijk te scannen zijn. Het opslaan van meer dan 400 tekens kan resulteren in een zeer complexe QR-code die zelden kan worden gescand.',
          },
          {
            title: 'Foutdetectie in QR-codes',
            text: 'Een QR-code kan nog steeds worden gescand als er gegevens beschadigd zijn of bits worden gewijzigd. QR-code gebruikt Reed-Solomon-foutdetectietechniek om fouten op te sporen en deze na identificatie op te lossen.',
          },
        ],
        errorTitle: 'Foutcorrectieniveau QR-code:',
        errorIntro: 'Verschillende foutdetectie- en correctietechnieken worden in verschillende gevallen gebruikt, zoals hieronder beschreven:',
        errorHeaders: {
          level: 'Niveau',
          recovery: 'Herstelcapaciteit',
          bestUse: 'Best gebruik',
        },
        errorRows: [
          {
            level: 'Laag (L)',
            recovery: '~7%',
            useCases: [
              'Deze foutcorrectietechniek wordt gebruikt wanneer QR-code op digitale schermen, websites of in een schone omgeving wordt weergegeven.',
              'Wanneer een QR-code wordt gegenereerd voor kleine informatie, zoals Gmail, contactnummer of kleine tekst.',
            ],
          },
          {
            level: 'Gemiddeld (M)',
            recovery: '~15%',
            useCases: [
              'Voor folders en posters die in schone omgeving zijn geplaatst en waar het beschadigingsrisico verwaarloosbaar is.',
            ],
          },
          {
            level: 'Kwartiel (Q)',
            recovery: '~25%',
            useCases: [
              'Wanneer QR-code in een ruige omgeving moet worden geplaatst, zoals in fabriek/buiten.',
              'Ook wanneer een klein logo in het midden nodig is, bedekt het enkele bits. Dit foutcorrectieniveau is dus nodig.',
            ],
          },
          {
            level: 'Hoog (H)',
            recovery: '~30%',
            useCases: [
              'Gebruikt wanneer zware beschadiging van de QR-code mogelijk is.',
              'Wanneer grote logo\'s het midden van QR-code bedekken.',
              'Ook wanneer zware styling voor QR-code nodig is.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Waarom onze QR-codegenerator kiezen?',
        intro: 'Onze QR-codegenerator maakt QR-codegeneratie extreem snel, veilig en eenvoudig. Je kunt je code aanpassen om hem geavanceerder, professioneler en aansluitend op je zakenthema te maken. Alle aanpassingen, van het kleuren van de QR-code tot logoplaatsing in de QR-code, worden gratis aangeboden.',
        strengths: [
          {
            title: 'Professionele aanpassing:',
            text: 'Je kunt zoveel QR-codes genereren en aanpassen als je nodig hebt zonder kosten. Alle functies zijn volledig gratis. Je kunt gradiëntkleuren, verschillende vormen voor vierkante vakken, aangepaste logo\'s en veel meer functies toepassen.',
          },
          {
            title: 'Ondersteuning voor meerdere formaten:',
            text: 'Onze QR-codegenerator biedt meerdere downloadformaten voor je gemak. Je hoeft alleen je voorkeur selecteren voordat je downloadt. We bieden momenteel deze formaten:',
          },
          {
            title: 'Voorgemaakte sjablonen:',
            text: 'Je kunt voorgemaakte gradiëntkleuren en frames gebruiken die je QR-code professioneel maken.',
          },
          {
            title: 'Aangepaste logo-ondersteuning:',
            text: 'Je kunt ook je aangepaste merklogo uploaden dat automatisch in het midden van QR-code past. Je kunt ook een logo uit de ingebouwde logotheek selecteren waar meer dan 30 logo\'s beschikbaar zijn.',
          },
          {
            title: 'Live-voorbeeld:',
            text: 'Terwijl je aanpassingen maakt, kun je alle wijzigingen in het live-voorbeeldpaneel bekijken. Deze wijzigingen zijn realtime en veranderen dynamisch.',
          },
          {
            title: 'Scan-indicator:',
            text: 'Bij het kiezen van kleuren leiden juiste waarschuwingen en indicatoren je als je kleuren kiest die moeilijk te scannen zijn.',
          },
        ],
        formatHeaders: {
          srNo: 'Nr.',
          formats: 'Formaten',
          description: 'Beschrijving',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Verliesvrij, ondersteunt transparantie' },
          { no: '2', format: 'JPG', description: 'Populair, algemeen bestandsformaat' },
          { no: '3', format: 'WEBP', description: 'Modern, beste kwaliteit/grootte' },
          { no: '4', format: 'SVG', description: 'Schaalbare vectorafbeelding' },
          { no: '5', format: 'PDF', description: 'Afdrukgereed document' },
        ],
      },
      card3: {
        title: '3. Stap voor stap handleiding:',
        step1Intro: 'Selecteer eerst de categorie van de QR-code die je wilt genereren. Of je genereert QR-code voor contactpersoon, kaart, link of tekst. Momenteel biedt onze QR-codegenerator deze categorieën:',
        categories: ['Link / URL', 'Tekst', 'WiFi', 'Contactpersoon', 'Gmail', 'Google Maps'],
        step2: 'Plak je informatie na het selecteren van de categorie in het tekstvak.',
        step3Intro: 'Klik vervolgens op Genereren & Aanpassen om het aanpassingspaneel te openen. In het aanpassingspaneel zie je een subnavigatiebalk met de volgende opties:',
        options: [
          {
            title: 'Stijl & Vorm:',
            text: 'In dit gedeelte kunt u de vormen van vierkante vakken in meerdere stijlen wijzigen, zoals afgeronde hoeken, stippen, horizontale balken, verticale balken, kleine vierkanten en nog veel meer.',
          },
          {
            title: 'Kleur:',
            text: 'Je kunt aangepaste achtergrond- en voorgrondkleuren in dit gedeelte selecteren. Om je QR-code in gradiëntkleuren te maken, heb je de optie om gradiënt in te schakelen, waarmee je elk gradiëntkleur uit de ingebouwde bibliotheek kunt toepassen of eenvoudig je eigen gradiëntkleur kunt maken. Je kunt ook de hoek voor lineaire gradiëntkleur wijzigen. Radiële gradiënt wordt ook ondersteund. Je kunt meerdere kleuren toevoegen om een professioneel gradiënteffect te maken.',
          },
          {
            title: 'Frames:',
            text: 'Hier kunt u een perfect frame voor uw QR-code selecteren. Alle frames passen automatisch aan uw code aan. Je hoeft alleen maar een frame uit de ingebouwde bibliotheek te selecteren.',
          },
          {
            title: 'Logo:',
            text: 'Na frameelectie kunt u een logo selecteren dat automatisch in het midden van QR-code wordt aangepast. Upload van uw aangepaste merklogo wordt ook ondersteund.',
          },
          {
            title: 'Sjablonen:',
            text: 'Als je stijl, vorm, kleur en frame niet afzonderlijk wilt selecteren, kunt je voorgemaakte sjablonen op je QR-code toepassen. Meerdere premiumsjablonen zijn beschikbaar voor je gemak die gratis zijn.',
          },
          {
            title: 'Bestandsformaat:',
            text: 'Tenslotte moet u het bestandstype selecteren waarin u de QR-code wilt downloaden. Verschillende gangbare formaten worden ondersteund, inclusief PNG, WEBP, SVG en PDF, enz.',
          },
          {
            title: 'QR-gegevens bewerken:',
            text: 'U kunt uw QR-gegevens ook bewerken zonder verlies in uw geselecteerde aanpassingen.',
          },
        ],
        finalStep: 'Klik vervolgens op de downloadknop, en de QR-code volgens uw aanpassingen in het geselecteerde formaat wordt direct zonder kosten gedownload.',
      },
      card4: {
        title: '4. Voordelen:',
        intro: 'QR-code verbindt de fysieke wereld met de digitale ervaring. Het is de snelste manier om links, contactgegevens of uw locatie te delen. Je hoeft alleen maar die QR-code te scannen om direct toegang tot de informatie te krijgen. Daarom is het erg populair in bedrijven en digitale wereld omdat het tijdefficiënt en zeer doelgericht is.',
        benefits: [
          {
            title: 'Levenslange ondersteuning:',
            text: 'QR-codes werken voor altijd zonder verloopdatum. Ze geven je direct de opgeslagen informatie wanneer je ze scant. Omdat het hardcoded digitale instructies opslaat, verliest het nooit zijn informatie.',
          },
          {
            title: 'Offline ondersteuning:',
            text: 'Je kunt de QR-code scannen zelfs als je offline bent. Je mobiele camera decodert de patronen van de QR-code en geeft je de erin opgeslagen informatie.',
          },
          {
            title: 'Nul kosten:',
            text: 'Omdat deze codes geen serveromleidingen of resources vereisen, is het voor altijd kosteloos.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR-code Scanner — Scan QR-codes van Camera of Afbeelding | photremium.com',
      desc: 'Direct QR-codes scannen met camera of uploaden van afbeelding. Detecteert URL, tekst, WiFi, contacten en meer.',
      keywords: 'qr code scanner, qr code scannen, qr lezer, qr code online',
    },
    title: 'QR-code Scanner',
    desc: 'Direct QR-codes scannen met camera of uploaden van afbeelding. Snel en veilig.',
    generateQrCode: 'QR-code Genereren',
    scan: 'Scannen',
    cameraScanner: 'Camerascanner',
    uploadImage: 'Afbeelding Uploaden',
    pointCamera: 'Wijs camera op de QR-code',
    startCamera: 'Camera Starten',
    loading: 'Laden…',
    dropQrImage: 'QR-code afbeelding hier neerzetten',
    toScan: 'te scannen',
    supportedFormats: 'Ondersteunt JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Plakken via Ctrl+V',
    scanFromGallery: 'Scannen uit Galerij',
    instantScanning: 'Direct Scannen',
    instantScanningDesc: 'Realtime QR-codedetectie vanaf camera of geüploade afbeeldingen',
    private100: '100% Privé',
    private100Desc: 'Alle verwerking gebeurt in je browser. Niets wordt geüpload',
    multiFormat: 'Meerdere Formaten',
    multiFormatDesc: 'Detecteert URL\'s, tekst, WiFi, contacten, e-mail, telefoon en meer',
    accessingCamera: 'Toegang tot camera…',
    cameraDenied: 'Cameratoegang geweigerd. Sta camera-rechten toe en probeer opnieuw.',
    noCamera: 'Geen camera gevonden op dit apparaat.',
    cameraError: 'Kan geen toegang krijgen tot camera. Probeer opnieuw.',
    videoError: 'Kon videoweergave niet starten.',
    switchError: 'Kon camera niet wisselen.',
    tryAgain: 'Opnieuw Proberen',
    switchCamera: 'Camera Wisselen',
    stop: 'Stoppen',
    noQrFound: 'Geen QR-code Gevonden',
    couldNotRead: 'Afbeelding kan niet worden gelezen',
    scannerFailed: 'Scanner laden mislukt',
    noQrFoundDesc: 'Geen QR-code gedetecteerd in de afbeelding. Probeer een andere afbeelding of gebruik de camerascanner.',
    qrScanned: 'QR-code Gescand!',
    openLink: 'Link Openen',
    copied: 'Gekopieerd!',
    copy: 'Kopiëren',
    share: 'Delen',
    scanAgain: 'Opnieuw Scannen',
    network: 'Netwerk',
    password: 'Wachtwoord',
    security: 'Beveiliging',
    unknown: 'Onbekend',
    typeText: 'Tekst',
    typeUrl: 'URL',
    typeWifi: 'WiFi-netwerk',
    typeContact: 'Contactkaart',
    typeEmail: 'E-mail',
    typePhone: 'Telefoonnummer',
    typeSms: 'SMS',
    typeLocation: 'Locatie',
    blog: {
      tocTitle: 'Inhoud',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Waarom een QR-codescanner gebruiken?',
          paragraphs: [
            'Een QR-codescanner is in feite een mobiele camera die de informatie decodeert die in de QR-code is opgeslagen. Je hoeft alleen de camera op de QR-code te richten; ongeacht de oriëntatie van de QR-code leest hij specifieke patronen, detecteert fouten, corrigeert fouten indien nodig en toont de informatie erin.',
          ],
          listTitle: 'Soorten QR-codescanners:',
          bullets: [
            'Webgebaseerde QR-codescanner: Je kunt de QR-code scannen met online scanners die je browser ondersteunt. Je kunt de informatie openen via de camera of door een afbeelding te uploaden. Voor automatische doorverwijzing en andere geavanceerde functies kun je https://photremium.com bezoeken.',
            'Mobiele camera\'s: Sommige moderne telefoons hebben een ingebouwde QR-codescanner in hun standaard camera-apps. Deze kunnen informatie ophalen en decoderen door de QR-code met een gewone camera te scannen.',
            'Apps: Er zijn apps die speciaal zijn gemaakt om QR-codes te scannen. Voor geavanceerde doorverwijzing en veel andere functies kun je de app echter gratis installeren via deze link: https://photremium.com.',
            'Hardware-apparaten: Er zijn ook hardware-apparaten gemaakt om QR-codes te scannen. Deze apparaten worden veel gebruikt in grote winkelcentra voor het afrekenen van producten.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Waarom kiezen voor onze QR-codescanner?',
          paragraphs: [
            'Je kunt meerdere geavanceerde functies verkennen, van doorverwijzen tot het kopiëren van inhoud die uit de QR-code is gedecodeerd. Je kunt nog veel meer interessante functies in onze QR-codescanner ontdekken, zoals:',
          ],
          bullets: [
            'Hoge snelheid: Onze QR-codescanner maakt het decoderen van QR-codes extreem snel. Je hoeft alleen de QR-code te scannen, en onze tool geeft direct de informatie met geavanceerde opties om tekst/link te kopiëren, te openen als er een link is gedetecteerd, of automatisch op te slaan als er een contact is gedetecteerd.',
            'Geen installatie nodig: Je hoeft geen aparte app te installeren om onze QR-codescanner te gebruiken. Je kunt deze tool gratis via je lokale browser openen.',
            'Platformonafhankelijke toegang: Je kunt het op elk apparaat gebruiken. Geen zorgen over OS-versie of andere vereisten. Dit wordt ondersteund op alle versies en alle apparaten.',
            'Alle formaten ondersteund: Alle gegevensformaten die in de QR-code kunnen worden opgeslagen, waaronder platte tekst, WiFi, URL\'s, contacten, Gmail en Google Maps, enz., worden door onze tool ondersteund.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Stapsgewijze handleiding:',
          steps: [
            {
              heading: '1. Kies eerst een methode om de QR-code te scannen. Er zijn twee methoden:',
              subSteps: [
                {
                  heading: 'i. Cameramethode',
                  paragraphs: [
                    'Je kunt de QR-code scannen met de camera van je apparaat, zelfs als je een laptop, pc of ander apparaat gebruikt dat een gewone camera ondersteunt. Door op de knop “Start Camera” te klikken verschijnt een toestemmingsverzoek; geef deze site toestemming om je camera te gebruiken voor QR-scannen. Als je per ongeluk hebt geweigerd of het verzoek niet verschijnt, kun je cameratoegang handmatig verlenen met deze stappen:',
                  ],
                  notes: [
                    '➔ Voor Chrome (Android / Desktop):',
                    '1. Klik op de drie puntjes',
                    '2. Ga naar Settings',
                    '3. (Sla deze stap over op Android) Privacy and Security',
                    '4. Klik op Site Settings',
                    '5. Klik daarna in de permissions-sectie op Camera',
                    '6. Zoek de URL van onze site: https://photremium.com/qr-code-scanner',
                    '7. Sta camera toe via het dropdownmenu.',
                    '➔ Voor Safari (iPhone / iOS):',
                    '1. Tik op het AA- of Website Settings-icoon in de adresbalk.',
                    '2. Selecteer Website Settings.',
                    '3. Tik op Camera en kies Allow.',
                    '4. Als het nog steeds geblokkeerd is: ga naar iPhone Settings > Safari > Camera en zet dit op Ask of Allow.',
                  ],
                },
                {
                  heading: 'ii. Galerijmethode',
                  paragraphs: [
                    'Je kunt een afbeelding van een QR-code uploaden om de informatie te openen. Klik op de knop “Scan from Gallery” en de bestandsverkenner wordt geopend. Selecteer daarna de QR-codeafbeelding. Alle afbeeldingsformaten worden ondersteund zoals jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz en .xbm, enz.',
                  ],
                },
              ],
            },
            {
              heading: '2. Wanneer je de QR-code selecteert, wordt alle informatie weergegeven; je kunt dan kopiëren, delen of de link openen als die is gedetecteerd. Je kunt ook opnieuw scannen als je wilt.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Voordelen van QR-codescanner:.',
          paragraphs: [
            'De QR-codescanner biedt verschillende voordelen in deze digitale wereld. Het maakt betalingen, verificaties en toegang tot informatie gemakkelijk en snel, zelfs in offline modus.',
          ],
          bullets: [
            'Directe toegang tot informatie: Het scannen van de QR-code levert informatie op in milliseconden. Het decodeert patronen, detecteert fouten en verwijdert ze razendsnel, wat de gebruiker een zeer snelle ervaring geeft.',
            'Naadloze communicatie: In dit tijdperk van vooruitgang is er veel behoefte aan snelle en veilige communicatie voor kleine informatie zoals bankgegevens en productdetails, enz. De QR-codescanner lost dit op omdat betalingen worden gedaan door een QR-code te scannen. Google verifieert ook mobiele telefoons via QR bij het maken van een nieuw account op laptop.',
            'E-tickets: Op busstations, treinstations of luchthavens kun je je tickets eenvoudig verifiëren zonder lang in de rij te wachten. Bovendien zijn op meerdere plekken op luchthavens QR-codescanners geïnstalleerd om wachtrijen te voorkomen. Dit vermindert ook de behoefte aan personeel en bespaart zo automatisch op het budget van de luchtvaartmaatschappij.',
            'Productauthenticatie: Geavanceerde en premium merken plaatsen een QR-code op hun product. Klanten kunnen die QR-code scannen om de echtheid van het product te controleren.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Gezicht Vervagen Tool — Vervag Gezichten op Afbeeldingen Online | photremium.com',
      uploadDesc: 'Automatisch gezichten vervagen op afbeeldingen met AI. Kies intensiteit, vorm of emoji.',
      uploadKeywords: 'gezicht vervagen, gezicht vervaagd, gezichtsdetectie, privacy tool',
      workspaceTitle: 'Gezicht Vervagen Tool — photremium.com',
      workspaceDesc: 'Automatisch gezichten vervagen op afbeeldingen. 100% gratis.',
      workspaceKeywords: 'gezicht vervagen, gezichtsdetectie',
    },
    title: 'Gezicht Vervagen',
    desc: 'Detecteer en vervaag automatisch gezichten op afbeeldingen om privacy te beschermen.',
    toBlurFaces: 'gezichten te vervagen',
    autoDetection: 'Automatische Detectie',
    autoDetectionDesc: 'AI-gestuurde gezichtsdetectie vindt direct alle gezichten',
    customBlur: 'Aangepaste Vervaging',
    customBlurDesc: 'Pas intensiteit, vorm en stijl van vervaging aan',
    private100: '100% Privé',
    private100Desc: 'Alle verwerking vindt lokaal plaats in de browser',
    blurTools: 'Vervagingstools',
    faces: 'Gezichten',
    faceDetection: 'Gezichtsdetectie',
    detecting: 'Detecteren...',
    autoDetectFaces: 'Gezichten Automatisch Detecteren',
    exitManualMode: 'Handmatige Modus Verlaten',
    manualSelect: 'Handmatige Selectie',
    nFaceRegions: '{n} gezichtsgebieden gevonden',
    noFacesDetected: 'Geen gezichten gedetecteerd — gebruik handmatige modus',
    manualHint: 'Klik en sleep om een rechthoek te tekenen over het te vervagen gebied.',
    blurType: 'Vervagingstype',
    blur: 'Vervaging',
    emoji: 'Emoji',
    blurIntensity: 'Vervagingsintensiteit',
    strength: 'Sterkte',
    blurShape: 'Vervagingsvorm',
    rectangle: 'Rechthoek',
    ellipse: 'Ellips',
    circle: 'Cirkel',
    chooseEmoji: 'Emoji Kiezen',
    blurRegionsN: 'Vervagingsgebieden ({n})',
    faceN: 'Gezicht {n}',
    manualRegionN: 'Handmatig Gebied {n}',
    manualN: 'Handmatig {n}',
    clearAllRegions: 'Alle Gebieden Wissen',
    processingDots: 'Verwerken...',
    downloadBlurred: 'Vervaagde Afbeelding Downloaden',
    downloadNImages: '{n} Afbeeldingen Downloaden',
    downloadDialogTitle: 'Niet Alle Afbeeldingen Zijn Bewerkt',
    downloadDialogText: '{edited} van {total} bewerkt.',
    downloadAll: 'Alles Downloaden',
    removeRegion: 'Gebied Verwijderen',
    region: 'Gebied',
    notAllEdited: 'Niet Alle Afbeeldingen Zijn Bewerkt',
    editedXofY: '{edited} van {total} bewerkt.',
    nextImage: 'Volgende Afbeelding',
  },

  faqData: {
    imageConverter: [
      { q: 'Welke afbeeldingsformaten worden ondersteund voor conversie?', a: 'We ondersteunen JPG, PNG, WEBP, SVG, GIF, BMP, ICO en TIFF. U kunt direct converteren tussen deze formaten in de browser.' },
      { q: 'Blijft de afbeeldingskwaliteit behouden tijdens conversie?', a: 'Voor verliesloze formaten zoals PNG blijft de kwaliteit volledig behouden. Voor verliesformaten zoals JPG en WEBP gebruiken we geoptimaliseerde coderingsinstellingen.' },
      { q: 'Zijn er beperkingen qua grootte of aantal bestanden?', a: 'Geen strenge beperkingen. U kunt meerdere afbeeldingen tegelijk uploaden en in batch converteren.' },
      { q: 'Zijn mijn gegevens veilig? Worden afbeeldingen naar een server gestuurd?', a: 'Absoluut. Alle verwerking vindt in uw browser plaats. Uw afbeeldingen verlaten nooit uw apparaat.' },
      { q: 'Kan ik transparante PNG naar JPG converteren?', a: 'Ja. Omdat JPG geen transparantie ondersteunt, worden transparante gebieden standaard gevuld met een witte achtergrond.' },
    ],
    imageCompressor: [
      { q: 'Zal het comprimeren van een afbeelding de kwaliteit verlagen?', a: 'Nee, het comprimeren van een afbeelding verlaagt de kwaliteit niet merkbaar zolang u binnen de aanbevolen grenzen blijft. De indicatoren helpen u bij de kwaliteit: i. Compressie 1% tot 40%: groene indicator met bericht “Goede kwaliteit”. ii. Compressie 41% tot 60%: gele indicator met bericht “Normale kwaliteit”. Dit bereik wordt meestal aanbevolen. iii. Compressie 61% tot 100%: het systeem toont een rode waarschuwing “Slechte kwaliteit”; in dit bereik kan kwaliteitsverlies duidelijk zichtbaar worden.' },
      { q: 'Welke afbeeldingsformaten worden ondersteund voor compressie?', a: 'Onze afbeeldingscompressor ondersteunt alle onderstaande formaten:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Kan ik meerdere afbeeldingen tegelijk comprimeren?', a: 'Ja, zeker. U kunt meerdere afbeeldingen tegelijk comprimeren (zelfs 100+) als uw systeem dat ondersteunt. Omdat compressie apparaatbronnen gebruikt, presteert een krachtige laptop, pc of telefoon beter. Heeft u een minder krachtig apparaat, dan kunt u in batches comprimeren; de tool blijft ook dan gratis te gebruiken.' },
      { q: 'Slaan jullie onze afbeeldingen op of uploaden jullie ze naar jullie servers?', a: 'Nee, wij uploaden of bewaren uw afbeeldingen nooit op onze servers. Alle afbeeldingen worden lokaal in uw browser gecomprimeerd. Uw bestanden verlaten uw apparaat nooit, dus u kunt persoonlijke of privéafbeeldingen zonder zorgen comprimeren.' },
      { q: 'Is deze afbeeldingscompressietool gratis te gebruiken?', a: 'Ja, onze afbeeldingscompressor is volledig gratis en blijft dat ook. We vragen nooit om betaling. Er zijn geen verborgen kosten. Alle functies, inclusief het comprimeren van meerdere afbeeldingen, zijn gratis.' },
    ],
    cropImage: [
      { q: 'Verlaagt het bijsnijden van een afbeelding de kwaliteit?', a: 'Nee, het bijsnijden van een afbeelding heeft geen invloed op de visuele kwaliteit van de afbeelding. Bijsnijden verwijdert alleen het ongewenste deel. Het verandert nooit de pixels van het deel dat overblijft na het bijsnijden. U kunt uw afbeeldingen dus in originele kwaliteit bijsnijden zonder pixelbeschadiging.' },
      { q: 'Welke afbeeldingsformaten ondersteunt de afbeelding-bijsnijder?', a: 'U kunt afbeeldingen in elk formaat kiezen, omdat onze afbeelding-bijsnijder vrijwel alle afbeeldingsformaten ondersteunt. Hieronder vindt u de lijst:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Worden mijn afbeeldingen naar jullie server geüpload?', a: 'Nee, alle verwerking gebeurt in uw lokale browser. Uw afbeeldingen worden nooit naar onze server geüpload, omdat ze uw apparaat niet verlaten. U kunt dus persoonlijke afbeeldingen zonder risico bijsnijden met onze afbeelding-bijsnijder.' },
      { q: 'Kan ik meerdere afbeeldingen tegelijk bijsnijden?', a: 'Ja, u kunt meerdere afbeeldingen (zelfs 100+) tegelijk bijsnijden als uw systeem dit ondersteunt. Omdat bijsnijden systeembronnen gebruikt, kunt u met een krachtige laptop, pc of telefoon veel afbeeldingen in één keer bijsnijden. Heeft u een minder krachtig apparaat, dan kunt u in batches bijsnijden; de tool blijft gratis, ook bij veel afbeeldingen tegelijk.' },
      { q: 'Is deze afbeelding-bijsnijder gratis te gebruiken?', a: 'Ja, deze afbeelding-bijsnijder is volledig gratis voor altijd. U kunt de tool overal, altijd en op elk apparaat gebruiken. U krijgt een responsief ontwerp voor alle apparaten en u wordt nooit gevraagd te betalen voor premiumfuncties. Alle functies zijn volledig gratis, zonder verborgen kosten.' },
    ],
    resizeImage: [
      { q: 'Kan ik meerdere afbeeldingen tegelijk van formaat wijzigen?', a: 'Jazeker. Onze afbeelding-resizer ondersteunt het tegelijk schalen van meerdere afbeeldingen. U kunt zoveel afbeeldingen uploaden als uw apparaat aankan; de AI-engine verwerkt ze tegelijk. Op tragere apparaten is verwerken in batches aan te raden om vertraging te voorkomen. Alles gebeurt lokaal zonder serverupload, dus uw privacy blijft beschermd.' },
      { q: 'Is deze afbeelding-resizer gratis?', a: 'Ja, deze tool is volledig gratis voor altijd. Er is geen betaald abonnement nodig voor premiumfuncties. Er zijn ook geen verborgen kosten bij het downloaden van geschaalde afbeeldingen.' },
      { q: 'Verliest een afbeelding kwaliteit bij formaat wijzigen?', a: '✅Decrease Size (downscale): Het verkleinen van een afbeelding verlaagt de visuele kwaliteit niet. In veel gevallen kan de verkleinde afbeelding zelfs scherper lijken. Verkleinen naar een kleinere maat veroorzaakt dus meestal geen kwaliteitsverlies.\n❌Increase Size (upscale): Vergroten boven de originele grootte kan de visuele kwaliteit wel beïnvloeden. Hoe sterker u vergroot, hoe groter de kans op kwaliteitsverlies.' },
      { q: 'Is deze afbeelding-resizer veilig?', a: 'Ja, onze tool is veilig, ook voor persoonlijke of gevoelige afbeeldingen. Alle verwerking gebeurt lokaal op uw apparaat en geen data verlaat uw systeem. U kunt dus zonder privacyrisico schalen.' },
      { q: 'Welke afbeeldingsformaten worden ondersteund?', a: 'Onze afbeelding-resizer ondersteunt alle afbeeldingsformaten. U kunt afbeeldingen in de volgende formaten kiezen:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Hoe werkt achtergrondverwijdering?', a: 'We gebruiken geavanceerde AI-modellen die direct in de browser draaien om het onderwerp te detecteren en te scheiden van de achtergrond.' },
      { q: 'Werkt het voor complexe achtergronden?', a: 'Ja. Het AI-model verwerkt diverse scènes. De beste resultaten worden bereikt bij duidelijk contrast tussen onderwerp en achtergrond.' },
      { q: 'Kan ik achtergronden van meerdere afbeeldingen tegelijk verwijderen?', a: 'Ja. Upload meerdere afbeeldingen en de tool verwerkt ze opeenvolgend.' },
      { q: 'Wat is het uitvoerformaat?', a: 'De uitvoer is altijd een PNG-bestand met transparante achtergrond.' },
      { q: 'Worden mijn afbeeldingen naar een server gestuurd?', a: 'Nee. Het AI-model draait volledig in de browser met WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Is het Photremium watermerkgereedschap gratis?', a: 'Ja, het gereedschap op photremium.com/watermark-image is gratis en vereist geen account of abonnement. U kunt watermerken aan enkelvoudige afbeeldingen of hele batches toevoegen zonder betaalmuur.' },
      { q: '2. Hoeveel afbeeldingen kan ik tegelijk verwerken?', a: 'Het gereedschap ondersteunt batch verwerking. U kunt een hele map slepen of meerdere bestanden tegelijk selecteren — de praktische limiet wordt bepaald door het geheugen van uw apparaat.' },
      { q: '3. Welke beeldformaten worden ondersteund?', a: 'Ondersteunt formaten die door de File API worden gelezen: JPEG, JPG, PNG, WEBP, GIF (statisch), BMP en SVG. De uitvoer behoudt het originele formaat.' },
      { q: '4. Ziet het watermerk er hetzelfde uit op verschillende resoluties?', a: 'Ja. De proportionele positioneringsengine berekent relatieve positie en schaal, waardoor het uiterlijk van het watermerk binnen een batch consistent blijft.' },
      { q: '5. Kan ik mijn eigen logo als watermerk gebruiken?', a: 'Ja. Met de knop "Add Image" kunt u een PNG met transparante achtergrond uploaden dat als watermerklaag wordt gebruikt.' },
      { q: '6. Hoe maak ik het watermerk halfdoorzichtig?', a: 'Selecteer de watermerklaag op het canvas en pas de dekking aan met de schuifregelaar. 30–50% geeft meestal een subtiel, professioneel resultaat.' },
      { q: '7. Kan ik meerdere watermerklagen in één afbeelding toevoegen?', a: 'Ja. Het lagen systeem ondersteunt meerdere lagen, elk met eigen instellingen.' },
      { q: '8. Wat doet de tiling-functie en wanneer gebruik je die?', a: 'Tiling herhaalt het watermerk in een raster over de hele afbeelding; handig om ongeautoriseerd gebruik te ontmoedigen.' },
      { q: '9. Werkt het gereedschap op mobiele apparaten?', a: 'Ja — de interface is responsive: miniaturen worden een scrollbare rij, het instellingenpaneel verschijnt als een onderlade en bedieningselementen ondersteunen touch.' },
      { q: '10. Zijn mijn afbeeldingen privé en worden ze naar een server gestuurd?', a: 'Uw afbeeldingen blijven op uw apparaat. Alle verwerking gebeurt lokaal in de browser met Canvas API; er is geen upload van afbeeldingsgegevens.' },
    ],
    qrCodeGenerator: [
      { q: 'Verloopt deze QR-code?', a: 'Nee, deze QR-codes vervallen niet en garanderen ondersteuning voor het leven. Omdat zij gehardcodeerde instructies opslaan in de vorm van bits in vierkante vaken, kan de informatie erin niet worden gewijzigd of verwijderd. U kunt de informatie in de code gewoon openen door deze met elke camera te scannen, zelfs na jaren.' },
      { q: 'Waarom wordt mijn QR-code niet gescand?', a: 'Uw QR-code kan om de volgende redenen niet worden gescand: i. Laag contrast: Als u gelijke achtergrond- en voorgrondkleuren selecteert, heeft dit invloed op de zichtbaarheid van de QR-code en zorgt dit voor scanfouten. Maar ons gereedschap begeleidt u tijdens het aanpassen over laag contrast of een ander scangerelateerd probleem. ii. Grote gegevens: Als u een QR-code genereert voor zeer grote tekst of gegevens, wordt deze erg complex en veroorzaakt problemen bij het scannen. Een tekstlengteverificatie begeleidt u over de optimale tekstlengte bij het genereren van QR-codes. iii. Wazig afdrukken: Zorg ervoor dat u uw QR-code downloadt in een hoge resolutie-indeling zoals PNG of SVG, die al door ons gereedschap worden ondersteund.' },
      { q: 'Kan ik een logo aan de QR-code toevoegen?', a: 'Absoluut, u kunt een aangepast logo toevoegen of er een kiezen uit de ingebouwde logotheek voor uw QR-code. Het logo dat u hebt geselecteerd, wordt automatisch in het midden van de QR-code geplaatst.' },
      { q: 'Hoe kan ik de QR-code scannen?', a: 'U kunt de QR-code scannen met uw mobiele camera. Maar voor automatische omleiding naar de koppeling en veel meer geavanceerde functies, kunt u onze QR-code-scanner gratis bezoeken met behulp van de koppeling https://photremium.com/qr-code-scanner.' },
      { q: 'Hoeveel QR-codes kan ik gratis genereren?', a: 'ONBEPERKT! u kunt meerdere QR-codes gratis genereren. Alle functies, aanpassingen en sjablonen zijn voor altijd gratis voor iedereen. U hoeft zich niet in te schrijven om te genieten van premiumfuncties.' },
      { q: 'Moet ik inloggen/inschrijven om een QR-code te genereren?', a: 'Nee, voer uw tekst in, genereer de QR-code en download deze na het aanpassen. U hoeft niet in te loggen of in te schrijven, omdat alle functies volledig gratis toegankelijk zijn.' },
    ],
    qrCodeScanner: [
      { q: 'Kan ik een QR-code scannen vanaf opgeslagen afbeeldingen en screenshots?', a: '**Ja**, je kunt een QR-code scannen vanaf opgeslagen afbeeldingen of screenshots. Onze QR-codescanner https://photremium.com/qr-code-scanner laat je de QR-code uit de galerij scannen. Je hoeft alleen de afbeelding te selecteren en je krijgt alle informatie die uit die QR-code is gehaald.' },
      { q: 'Moet ik de app installeren voor een QR-codescanner?', a: '**Nee**, onze webgebaseerde QR-codescanner laat je QR-codes scannen zonder dat je een app hoeft te installeren. Je kunt onze geavanceerde QR-codescanner gratis op elk apparaat gebruiken.' },
      { q: 'Waarom herkent de scanner de QR-code niet?', a: 'Je QR-code wordt niet gescand door een van de volgende redenen: i. Onvoldoende licht: Het scannen van de QR-code in weinig licht kan problemen geven. Zet de zaklamp aan en verhoog de helderheid als je vanaf een scherm scant. ii. Afstand: Scannen vanaf een onjuiste afstand veroorzaakt ook problemen. De optimale afstand om de QR-code te scannen is ongeveer 10 inch (25cm). iii. Vuile cameralenzen: QR-code scannen kan ook mislukken door vuile lenzen. Maak de lenzen schoon voordat je scant. “Zie je een rastervak in de scanner? Plaats de QR-code er gewoon in om hem succesvol te scannen.”' },
      { q: 'Scant deze tool een omgekeerde of kleurrijke QR-code?', a: '**Ja**, je kunt QR scannen in elke kleur of oriëntatie. Als het contrast tussen achtergrond en voorgrondkleur laag is, kan dit het scannen wel bemoeilijken.' },
      { q: 'Is deze tool gratis te gebruiken?', a: '**Ja**, deze tool is volledig gratis te gebruiken. Je kunt onbeperkt QR-codes gratis voor altijd scannen.' },
    ],
    faceBlur: [
      { q: 'Hoe werkt gezichtsdetectie?', a: 'Het AI-gestuurde gezichtsdetectiemodel draait direct in uw browser. Het identificeert gezichten in afbeeldingen.' },
      { q: 'Kan ik kiezen welke gezichten worden vervaagd?', a: 'Ja. Na detectie wordt elk gezichtsgebied gemarkeerd en u kunt kiezen welke gezichten u wilt vervagen.' },
      { q: 'Welke vervagingsstijlen zijn beschikbaar?', a: 'U kunt Gaussische vervaging, pixelisatie of een effen kleuroverlap kiezen en de intensiteit aanpassen.' },
      { q: 'Kan ik gezichten op meerdere afbeeldingen tegelijk vervagen?', a: 'Ja. Upload meerdere afbeeldingen, configureer de vervagingsgebieden en download alle verwerkte afbeeldingen.' },
      { q: 'Worden mijn foto\'s naar externe servers gestuurd?', a: 'Nee. Het AI-model draait in uw browser met WebAssembly.' },
    ],
    photoEditor: [
      { q: 'Welke bewerkingsfuncties zijn beschikbaar?', a: 'Helderheid, contrast, verzadiging aanpassen, filters toepassen, tekst, overlays, frames en stickers toevoegen — allemaal in de browser.' },
      { q: 'Kan ik ongedaan maken en opnieuw uitvoeren?', a: 'Ja. De editor ondersteunt volledige ongedaan maken/opnieuw-geschiedenis.' },
      { q: 'Welke bestandsformaten kunnen worden bewerkt en geëxporteerd?', a: 'U kunt JPG, PNG, WEBP en andere populaire formaten bewerken.' },
      { q: 'Werkt de editor op telefoons?', a: 'Ja. De editor is volledig responsief en aanraakvriendelijk.' },
      { q: 'Worden mijn afbeeldingen op een server opgeslagen?', a: 'Nee. Alle bewerking vindt lokaal plaats.' },
    ],
  },
};

export default nl;
